// import React, { useState, useRef, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import config from "../Components/Config/config";
// import {
//   ArrowLeft,
//   ArrowRight,
//   ZoomIn,
//   ZoomOut,
//   Maximize2,
//   Home,
//   ChevronLeft,
//   ChevronRight,
// } from "lucide-react";

// const BatchImageViewer = () => {
//   const navigate = useNavigate();
//   const { batchName } = useParams();

//   const [imageList, setImageList] = useState([]);
//   const [filteredImages, setFilteredImages] = useState([]);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [imageUrl, setImageUrl] = useState(null);
//   const [isListLoading, setIsListLoading] = useState(false);
//   const [isImageLoading, setIsImageLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [imageSize, setImageSize] = useState({ width: 0, height: 0 });
//   const [scale, setScale] = useState(1);
//   const [position, setPosition] = useState({ x: 0, y: 0 });
//   const [isDragging, setIsDragging] = useState(false);
//   const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
//   const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

//   // Prefetch state
//   const [prefetchedImages, setPrefetchedImages] = useState(new Map());
//   const [prefetchQueue, setPrefetchQueue] = useState(new Set());

//   const itemsPerPage = 10;
//   const imageRef = useRef(null);
//   const containerRef = useRef(null);

//   const [notification, setNotification] = useState({
//     show: false,
//     message: "",
//     type: "",
//   });

//   useEffect(() => {
//     if (batchName) {
//       fetchImageList();
//     } else {
//       navigate("/");
//     }
//   }, [navigate, batchName]);

//   useEffect(() => {
//     const filtered = imageList.filter((image) =>
//       image.filename.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     const sortedFiltered = [...filtered].sort((a, b) =>
//       a.filename.localeCompare(b.filename)
//     );

//     setFilteredImages(sortedFiltered);
//     setCurrentPage(1);
//   }, [searchTerm, imageList]);

//   useEffect(() => {
//     if (selectedImage) {
//       loadImage(selectedImage);
//     }
//   }, [selectedImage]);

//   useEffect(() => {
//     setScale(1);
//     setPosition({ x: 0, y: 0 });
//   }, [imageUrl]);

//   // Prefetch logic
//   useEffect(() => {
//     if (!selectedImage || filteredImages.length === 0) return;

//     const currentIndex = filteredImages.findIndex(
//       (img) => img.filename === selectedImage
//     );
//     if (currentIndex === -1) return;

//     const imagesToPrefetch = [];

//     // Previous image
//     if (currentIndex > 0) {
//       imagesToPrefetch.push(filteredImages[currentIndex - 1].filename);
//     }

//     // Next image
//     if (currentIndex < filteredImages.length - 1) {
//       imagesToPrefetch.push(filteredImages[currentIndex + 1].filename);
//     }

//     // Cleanup old prefetched images
//     cleanupPrefetchedImages(imagesToPrefetch);

//     // Start prefetching
//     imagesToPrefetch.forEach((imageName) => {
//       if (!prefetchedImages.has(imageName) && !prefetchQueue.has(imageName)) {
//         setTimeout(() => {
//           prefetchImage(imageName);
//         }, 0);
//       }
//     });
//   }, [selectedImage, filteredImages]);

//   // Cleanup on unmount
//   useEffect(() => {
//     return () => {
//       prefetchedImages.forEach((imageUrl) => {
//         URL.revokeObjectURL(imageUrl);
//       });
//     };
//   }, []);

//   const showNotification = (message, type) => {
//     setNotification({ show: true, message, type });
//     setTimeout(() => {
//       setNotification({ show: false, message: "", type: "" });
//     }, 3000);
//   };

//   const fetchImageList = async () => {
//     try {
//       setIsListLoading(true);
//       const url = `${config.API_BASE_URL}/api/batch_viewer/list_images/?batch_name=${encodeURIComponent(batchName)}`;

//       console.log("Fetching images from:", url);

//       const response = await fetch(url);

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error("Error fetching images:", errorText);
//         throw new Error(`Failed to fetch images: ${response.status}`);
//       }

//       const data = await response.json();
//       console.log("Images data:", data);

//       setImageList(data.images || []);

//       if (data.images && data.images.length > 0) {
//         setSelectedImage(data.images[0].filename);
//       }
//     } catch (error) {
//       console.error("Error fetching image list:", error);
//       showNotification("Failed to load images", "error");
//     } finally {
//       setIsListLoading(false);
//     }
//   };

//   const loadImage = async (imageName) => {
//     try {
//       // Check if image is prefetched
//       const prefetchedUrl = prefetchedImages.get(imageName);

//       if (prefetchedUrl) {
//         console.log("Using prefetched image:", imageName);
//         setImageUrl(prefetchedUrl);
//         return;
//       }

//       setIsImageLoading(true);
//       setImageUrl(null);

//       const url = `${config.API_BASE_URL}/api/batch_viewer/get_image/?batch_name=${encodeURIComponent(batchName)}&image_name=${encodeURIComponent(imageName)}`;
//       console.log("Loading image from:", url);

//       const response = await fetch(url);

//       if (!response.ok) {
//         throw new Error(`Failed to load image: ${response.status}`);
//       }

//       const imageBlob = await response.blob();
//       const newImageUrl = URL.createObjectURL(imageBlob);
//       setImageUrl(newImageUrl);
//     } catch (error) {
//       console.error("Error loading image:", error);
//       showNotification("Failed to load image", "error");
//     } finally {
//       setIsImageLoading(false);
//     }
//   };

//   const prefetchImage = async (imageName) => {
//     if (prefetchedImages.has(imageName) || prefetchQueue.has(imageName)) {
//       return;
//     }

//     setPrefetchQueue((prev) => new Set([...prev, imageName]));

//     try {
//       const url = `${config.API_BASE_URL}/api/batch_viewer/get_image/?batch_name=${encodeURIComponent(batchName)}&image_name=${encodeURIComponent(imageName)}`;
//       console.log("Prefetching image:", imageName);

//       const response = await fetch(url);

//       if (response.ok) {
//         const imageBlob = await response.blob();
//         const imageUrl = URL.createObjectURL(imageBlob);

//         setPrefetchedImages((prev) => {
//           const newMap = new Map(prev);
//           newMap.set(imageName, imageUrl);
//           return newMap;
//         });

//         console.log("Prefetched image:", imageName);
//       }
//     } catch (error) {
//       console.error(`Error prefetching image ${imageName}:`, error);
//     } finally {
//       setPrefetchQueue((prev) => {
//         const newSet = new Set(prev);
//         newSet.delete(imageName);
//         return newSet;
//       });
//     }
//   };

//   const cleanupPrefetchedImages = (currentTargets) => {
//     setPrefetchedImages((prev) => {
//       const newMap = new Map();

//       [...prev.entries()].forEach(([imageName, imageUrl]) => {
//         if (currentTargets.includes(imageName) || imageName === selectedImage) {
//           newMap.set(imageName, imageUrl);
//         } else {
//           URL.revokeObjectURL(imageUrl);
//         }
//       });

//       return newMap;
//     });
//   };

//   const handleImageSelect = (imageName) => {
//     if (isImageLoading) return;
//     setSelectedImage(imageName);
//   };

//   const handleImageLoad = (e) => {
//     const img = e.target;
//     setImageSize({
//       width: img.naturalWidth,
//       height: img.naturalHeight,
//     });
//   };

//   const handleZoomIn = () => {
//     setScale((prev) => Math.min(prev + 0.25, 5));
//   };

//   const handleZoomOut = () => {
//     setScale((prev) => Math.max(prev - 0.25, 0.5));
//   };

//   const handleResetZoom = () => {
//     setScale(1);
//     setPosition({ x: 0, y: 0 });
//   };

//   const handleMouseDown = (e) => {
//     if (scale > 1) {
//       setIsDragging(true);
//       setDragStart({
//         x: e.clientX - position.x,
//         y: e.clientY - position.y,
//       });
//     }
//   };

//   const handleMouseMove = (e) => {
//     if (isDragging) {
//       setPosition({
//         x: e.clientX - dragStart.x,
//         y: e.clientY - dragStart.y,
//       });
//     }
//   };

//   const handleMouseUp = () => {
//     setIsDragging(false);
//   };

//   const handlePreviousImage = () => {
//     const currentIndex = filteredImages.findIndex(
//       (img) => img.filename === selectedImage
//     );
//     if (currentIndex > 0) {
//       const prevImage = filteredImages[currentIndex - 1];
//       setSelectedImage(prevImage.filename);

//       const prevPage = Math.ceil(currentIndex / itemsPerPage);
//       if (prevPage !== currentPage) {
//         setCurrentPage(prevPage);
//       }
//     }
//   };

//   const handleNextImage = () => {
//     const currentIndex = filteredImages.findIndex(
//       (img) => img.filename === selectedImage
//     );
//     if (currentIndex < filteredImages.length - 1) {
//       const nextImage = filteredImages[currentIndex + 1];
//       setSelectedImage(nextImage.filename);

//       const nextPage = Math.ceil((currentIndex + 2) / itemsPerPage);
//       if (nextPage !== currentPage) {
//         setCurrentPage(nextPage);
//       }
//     }
//   };

//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.key === "ArrowLeft") {
//         e.preventDefault();
//         handlePreviousImage();
//       } else if (e.key === "ArrowRight") {
//         e.preventDefault();
//         handleNextImage();
//       } else if (e.key === "+" || e.key === "=") {
//         e.preventDefault();
//         handleZoomIn();
//       } else if (e.key === "-") {
//         e.preventDefault();
//         handleZoomOut();
//       } else if (e.key === "0") {
//         e.preventDefault();
//         handleResetZoom();
//       }
//     };

//     window.addEventListener("keydown", handleKeyDown);
//     return () => window.removeEventListener("keydown", handleKeyDown);
//   }, [selectedImage, filteredImages]);

//   const totalPages = Math.ceil(filteredImages.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const endIndex = startIndex + itemsPerPage;
//   const currentImages = filteredImages.slice(startIndex, endIndex);

//   const handlePageChange = (newPage) => {
//     setCurrentPage(newPage);
//   };

//   const currentImageIndex = filteredImages.findIndex(
//     (img) => img.filename === selectedImage
//   );

//   return (
//     <div className="flex h-screen bg-gray-100 relative">
//       {notification.show && (
//         <div
//           className={`fixed top-4 right-4 p-4 rounded-lg shadow-lg z-50 transition-all duration-300 ${
//             notification.type === "success" ? "bg-green-500" : "bg-red-500"
//           } text-white`}
//         >
//           {notification.message}
//         </div>
//       )}

//       {/* Prefetch Status Indicator */}
//       {prefetchQueue.size > 0 && (
//         <div className="fixed bottom-4 right-4 bg-blue-100 border border-blue-300 rounded px-3 py-2 text-sm z-40">
//           Prefetching {prefetchQueue.size} image(s)...
//         </div>
//       )}

//       {/* Image List Sidebar */}
//       <div
//         className={`bg-white border-r border-gray-200 overflow-y-auto transition-all duration-300 ease-in-out ${
//           isSidebarCollapsed ? "w-0" : "w-1/4"
//         }`}
//         style={{ minWidth: isSidebarCollapsed ? "0" : "250px" }}
//       >
//         <div className={`p-4 ${isSidebarCollapsed ? "hidden" : "block"}`}>
//           <div className="mb-6">
//             <div className="flex items-center justify-between mb-4">
//               <div className="flex-1 min-w-0">
//                 <h2 className="text-xl font-semibold truncate">Batch Viewer</h2>
//                 <p className="text-sm text-gray-600 mt-1 truncate">
//                   {decodeURIComponent(batchName)}
//                 </p>
//               </div>
//               <button
//                 onClick={() => navigate("/")}
//                 className="flex items-center gap-2 px-3 py-2 text-sm bg-gray-500 hover:bg-gray-600 text-white rounded transition-colors ml-2"
//                 title="Back to Home"
//               >
//                 <Home className="w-4 h-4" />
//                 <span className="hidden lg:inline">Home</span>
//               </button>
//             </div>

//             <div className="mb-4">
//               <input
//                 type="text"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 placeholder="Search images..."
//                 className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
//               />
//             </div>
//           </div>

//           {isListLoading ? (
//             <div className="flex items-center justify-center p-4">
//               <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
//             </div>
//           ) : (
//             <>
//               <div className="space-y-2 mb-4">
//                 {currentImages.length > 0 ? (
//                   currentImages.map((image, index) => (
//                     <div
//                       key={image.filename}
//                       onClick={() => handleImageSelect(image.filename)}
//                       className={`group relative p-3 rounded-lg border transition-all duration-200 cursor-pointer ${
//                         selectedImage === image.filename
//                           ? "bg-blue-50 border-blue-500 shadow-md"
//                           : "border-gray-200 hover:border-blue-300 hover:bg-gray-50"
//                       }`}
//                     >
//                       <div className="flex justify-between items-start gap-2">
//                         <div className="relative flex-1 min-w-0">
//                           <p className="text-sm font-medium text-gray-700 break-all leading-tight">
//                             {startIndex + index + 1}. {image.filename}
//                           </p>
//                           {/* Prefetch indicator */}
//                           {prefetchedImages.has(image.filename) && (
//                             <span className="text-xs text-green-600 mt-1 block">
//                               ✓ Ready
//                             </span>
//                           )}
//                           <div className="absolute left-0 -top-2 transform -translate-y-full opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10">
//                             <div className="bg-gray-900 text-white px-3 py-2 rounded text-xs whitespace-normal break-words max-w-xs">
//                               {image.filename}
//                             </div>
//                             <div className="w-2 h-2 bg-gray-900 transform rotate-45 translate-x-2 translate-y-[-4px] ml-2"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   ))
//                 ) : (
//                   <div className="text-center py-8 text-gray-500">
//                     {searchTerm
//                       ? "No images match your search"
//                       : "No images in this batch"}
//                   </div>
//                 )}
//               </div>

//               {totalPages > 0 && (
//                 <div className="border-t border-gray-200 pt-4 space-y-3">
//                   <div className="flex items-center justify-between">
//                     <button
//                       onClick={() => handlePageChange(currentPage - 1)}
//                       disabled={currentPage === 1}
//                       className={`px-3 py-1 rounded ${
//                         currentPage === 1
//                           ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                           : "bg-blue-500 text-white hover:bg-blue-600"
//                       }`}
//                     >
//                       Previous
//                     </button>
//                     <span className="text-sm text-gray-600">
//                       Page {currentPage} of {totalPages}
//                     </span>
//                     <button
//                       onClick={() => handlePageChange(currentPage + 1)}
//                       disabled={currentPage === totalPages}
//                       className={`px-3 py-1 rounded ${
//                         currentPage === totalPages
//                           ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                           : "bg-blue-500 text-white hover:bg-blue-600"
//                       }`}
//                     >
//                       Next
//                     </button>
//                   </div>
//                   <div className="text-center">
//                     <span className="text-xs text-gray-500">
//                       {filteredImages.length} total images
//                     </span>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}
//         </div>
//       </div>

//       {/* Collapse/Expand Toggle Button */}
//       <button
//         onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
//         className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white border border-gray-300 rounded-r-lg p-2 hover:bg-gray-100 transition-all duration-300 shadow-md z-30"
//         style={{
//           left: isSidebarCollapsed ? "0" : "calc(25% - 1px)",
//           minWidth: "32px",
//         }}
//         title={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
//       >
//         {isSidebarCollapsed ? (
//           <ChevronRight className="w-5 h-5 text-gray-600" />
//         ) : (
//           <ChevronLeft className="w-5 h-5 text-gray-600" />
//         )}
//       </button>

//       {/* Image Viewer */}
//       <div
//         className={`flex-1 p-6 overflow-hidden flex flex-col transition-all duration-300 ${
//           isSidebarCollapsed ? "ml-0" : ""
//         }`}
//       >
//         {selectedImage ? (
//           <div className="bg-white rounded-lg shadow-lg p-6 flex flex-col h-full">
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-xl font-semibold truncate mr-4">
//                 {selectedImage}
//               </h2>
//               <div className="text-sm text-gray-600 whitespace-nowrap">
//                 Image {currentImageIndex + 1} of {filteredImages.length}
//               </div>
//             </div>

//             {/* Zoom Controls */}
//             <div className="flex justify-between items-center mb-4">
//               <div className="flex items-center gap-2">
//                 <button
//                   onClick={handleZoomOut}
//                   disabled={scale <= 0.5}
//                   className={`p-2 rounded ${
//                     scale <= 0.5
//                       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                       : "bg-blue-500 text-white hover:bg-blue-600"
//                   }`}
//                   title="Zoom Out (-)"
//                 >
//                   <ZoomOut className="w-5 h-5" />
//                 </button>
//                 <span className="text-sm font-medium min-w-[60px] text-center">
//                   {Math.round(scale * 100)}%
//                 </span>
//                 <button
//                   onClick={handleZoomIn}
//                   disabled={scale >= 5}
//                   className={`p-2 rounded ${
//                     scale >= 5
//                       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                       : "bg-blue-500 text-white hover:bg-blue-600"
//                   }`}
//                   title="Zoom In (+)"
//                 >
//                   <ZoomIn className="w-5 h-5" />
//                 </button>
//                 <button
//                   onClick={handleResetZoom}
//                   className="p-2 bg-gray-500 text-white rounded hover:bg-gray-600"
//                   title="Reset Zoom (0)"
//                 >
//                   <Maximize2 className="w-5 h-5" />
//                 </button>
//               </div>

//               {/* Navigation Controls */}
//               <div className="flex items-center gap-2">
//                 <button
//                   onClick={handlePreviousImage}
//                   disabled={currentImageIndex === 0}
//                   className={`flex items-center gap-2 px-4 py-2 rounded ${
//                     currentImageIndex === 0
//                       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                       : "bg-blue-500 text-white hover:bg-blue-600"
//                   }`}
//                   title="Previous Image (←)"
//                 >
//                   <ArrowLeft className="w-4 h-4" />
//                   Previous
//                 </button>
//                 <button
//                   onClick={handleNextImage}
//                   disabled={currentImageIndex === filteredImages.length - 1}
//                   className={`flex items-center gap-2 px-4 py-2 rounded ${
//                     currentImageIndex === filteredImages.length - 1
//                       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                       : "bg-blue-500 text-white hover:bg-blue-600"
//                   }`}
//                   title="Next Image (→)"
//                 >
//                   Next
//                   <ArrowRight className="w-4 h-4" />
//                 </button>
//               </div>
//             </div>

//             {/* Image Container */}
//             <div
//               ref={containerRef}
//               className="relative flex-1 overflow-hidden bg-gray-50 rounded border border-gray-200"
//               onMouseDown={handleMouseDown}
//               onMouseMove={handleMouseMove}
//               onMouseUp={handleMouseUp}
//               onMouseLeave={handleMouseUp}
//               style={{
//                 cursor: isDragging
//                   ? "grabbing"
//                   : scale > 1
//                   ? "grab"
//                   : "default",
//               }}
//             >
//               {isImageLoading ? (
//                 <div className="flex items-center justify-center h-full">
//                   <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
//                 </div>
//               ) : (
//                 imageUrl && (
//                   <div className="w-full h-full flex items-center justify-center overflow-hidden">
//                     <img
//                       ref={imageRef}
//                       src={imageUrl}
//                       alt="Selected document"
//                       className="max-w-none"
//                       onLoad={handleImageLoad}
//                       style={{
//                         transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
//                         transition: isDragging
//                           ? "none"
//                           : "transform 0.2s ease-out",
//                         maxHeight: "100%",
//                         maxWidth: scale === 1 ? "100%" : "none",
//                         objectFit: "contain",
//                       }}
//                       draggable={false}
//                     />
//                   </div>
//                 )
//               )}
//             </div>

//             {/* Helper Text */}
//             <div className="mt-4 text-center text-sm text-gray-500">
//               Use arrow keys (← →) to navigate | Use +/- keys to zoom | Press 0
//               to reset zoom
//               {scale > 1 && " | Click and drag to pan"}
//             </div>
//           </div>
//         ) : (
//           <div className="flex items-center justify-center h-full bg-white rounded-lg shadow-lg">
//             <p className="text-gray-500 text-lg">
//               {isListLoading
//                 ? "Loading images..."
//                 : "No images available in this batch"}
//             </p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default BatchImageViewer;



////////////////////////added auth

// import React, { useState, useRef, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { useAuth } from "../AuthContext";
// import config from "../Components/Config/config";
// import {
//   ArrowLeft,
//   ArrowRight,
//   ZoomIn,
//   ZoomOut,
//   Maximize2,
//   Home,
//   ChevronLeft,
//   ChevronRight,
//   LogOut,
// } from "lucide-react";

// const BatchImageViewer = () => {
//   const navigate = useNavigate();
//   const { batchName } = useParams();
//   const { getToken, isAuthenticated, logout, user } = useAuth();

//   const [imageList, setImageList] = useState([]);
//   const [filteredImages, setFilteredImages] = useState([]);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [imageUrl, setImageUrl] = useState(null);
//   const [isListLoading, setIsListLoading] = useState(false);
//   const [isImageLoading, setIsImageLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [imageSize, setImageSize] = useState({ width: 0, height: 0 });
//   const [scale, setScale] = useState(1);
//   const [position, setPosition] = useState({ x: 0, y: 0 });
//   const [isDragging, setIsDragging] = useState(false);
//   const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
//   const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

//   // Prefetch state
//   const [prefetchedImages, setPrefetchedImages] = useState(new Map());
//   const [prefetchQueue, setPrefetchQueue] = useState(new Set());

//   const itemsPerPage = 10;
//   const imageRef = useRef(null);
//   const containerRef = useRef(null);

//   const [notification, setNotification] = useState({
//     show: false,
//     message: "",
//     type: "",
//   });

//   useEffect(() => {
//     if (!isAuthenticated()) {
//       navigate("/login");
//       return;
//     }

//     if (batchName) {
//       fetchImageList();
//     } else {
//       navigate("/");
//     }
//   }, [navigate, batchName, isAuthenticated]);

//   useEffect(() => {
//     const filtered = imageList.filter((image) =>
//       image.filename.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     const sortedFiltered = [...filtered].sort((a, b) =>
//       a.filename.localeCompare(b.filename)
//     );

//     setFilteredImages(sortedFiltered);
//     setCurrentPage(1);
//   }, [searchTerm, imageList]);

//   useEffect(() => {
//     if (selectedImage) {
//       loadImage(selectedImage);
//     }
//   }, [selectedImage]);

//   useEffect(() => {
//     setScale(1);
//     setPosition({ x: 0, y: 0 });
//   }, [imageUrl]);

//   // Prefetch logic
//   useEffect(() => {
//     if (!selectedImage || filteredImages.length === 0) return;

//     const currentIndex = filteredImages.findIndex(
//       (img) => img.filename === selectedImage
//     );
//     if (currentIndex === -1) return;

//     const imagesToPrefetch = [];

//     // Previous image
//     if (currentIndex > 0) {
//       imagesToPrefetch.push(filteredImages[currentIndex - 1].filename);
//     }

//     // Next image
//     if (currentIndex < filteredImages.length - 1) {
//       imagesToPrefetch.push(filteredImages[currentIndex + 1].filename);
//     }

//     // Cleanup old prefetched images
//     cleanupPrefetchedImages(imagesToPrefetch);

//     // Start prefetching
//     imagesToPrefetch.forEach((imageName) => {
//       if (!prefetchedImages.has(imageName) && !prefetchQueue.has(imageName)) {
//         setTimeout(() => {
//           prefetchImage(imageName);
//         }, 0);
//       }
//     });
//   }, [selectedImage, filteredImages]);

//   // Cleanup on unmount
//   useEffect(() => {
//     return () => {
//       prefetchedImages.forEach((imageUrl) => {
//         URL.revokeObjectURL(imageUrl);
//       });
//     };
//   }, []);

//   const showNotification = (message, type) => {
//     setNotification({ show: true, message, type });
//     setTimeout(() => {
//       setNotification({ show: false, message: "", type: "" });
//     }, 3000);
//   };

//   const handleLogout = () => {
//     logout();
//     navigate("/login");
//   };

//   const fetchImageList = async () => {
//     try {
//       setIsListLoading(true);
//       const token = getToken();

//       if (!token) {
//         navigate("/login");
//         return;
//       }

//       const url = `${config.API_BASE_URL}/api/batch_viewer/list_images/?batch_name=${encodeURIComponent(batchName)}`;

//       console.log("Fetching images from:", url);

//       const response = await fetch(url, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });

//       if (response.status === 401) {
//         // Token expired or invalid
//         showNotification("Session expired. Please login again.", "error");
//         logout();
//         navigate("/login");
//         return;
//       }

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error("Error fetching images:", errorText);
//         throw new Error(`Failed to fetch images: ${response.status}`);
//       }

//       const data = await response.json();
//       console.log("Images data:", data);

//       setImageList(data.images || []);

//       if (data.images && data.images.length > 0) {
//         setSelectedImage(data.images[0].filename);
//       }
//     } catch (error) {
//       console.error("Error fetching image list:", error);
//       showNotification("Failed to load images", "error");
//     } finally {
//       setIsListLoading(false);
//     }
//   };

//   const loadImage = async (imageName) => {
//     try {
//       // Check if image is prefetched
//       const prefetchedUrl = prefetchedImages.get(imageName);

//       if (prefetchedUrl) {
//         console.log("Using prefetched image:", imageName);
//         setImageUrl(prefetchedUrl);
//         return;
//       }

//       setIsImageLoading(true);
//       setImageUrl(null);

//       const token = getToken();

//       if (!token) {
//         navigate("/login");
//         return;
//       }

//       const url = `${config.API_BASE_URL}/api/batch_viewer/get_image/?batch_name=${encodeURIComponent(batchName)}&image_name=${encodeURIComponent(imageName)}`;
//       console.log("Loading image from:", url);

//       const response = await fetch(url, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//         },
//       });

//       if (response.status === 401) {
//         showNotification("Session expired. Please login again.", "error");
//         logout();
//         navigate("/login");
//         return;
//       }

//       if (!response.ok) {
//         throw new Error(`Failed to load image: ${response.status}`);
//       }

//       const imageBlob = await response.blob();
//       const newImageUrl = URL.createObjectURL(imageBlob);
//       setImageUrl(newImageUrl);
//     } catch (error) {
//       console.error("Error loading image:", error);
//       showNotification("Failed to load image", "error");
//     } finally {
//       setIsImageLoading(false);
//     }
//   };

//   const prefetchImage = async (imageName) => {
//     if (prefetchedImages.has(imageName) || prefetchQueue.has(imageName)) {
//       return;
//     }

//     setPrefetchQueue((prev) => new Set([...prev, imageName]));

//     try {
//       const token = getToken();

//       if (!token) {
//         return;
//       }

//       const url = `${config.API_BASE_URL}/api/batch_viewer/get_image/?batch_name=${encodeURIComponent(batchName)}&image_name=${encodeURIComponent(imageName)}`;
//       console.log("Prefetching image:", imageName);

//       const response = await fetch(url, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//         },
//       });

//       if (response.status === 401) {
//         // Token expired during prefetch - will be handled on next main request
//         console.log("Token expired during prefetch");
//         return;
//       }

//       if (response.ok) {
//         const imageBlob = await response.blob();
//         const imageUrl = URL.createObjectURL(imageBlob);

//         setPrefetchedImages((prev) => {
//           const newMap = new Map(prev);
//           newMap.set(imageName, imageUrl);
//           return newMap;
//         });

//         console.log("Prefetched image:", imageName);
//       }
//     } catch (error) {
//       console.error(`Error prefetching image ${imageName}:`, error);
//     } finally {
//       setPrefetchQueue((prev) => {
//         const newSet = new Set(prev);
//         newSet.delete(imageName);
//         return newSet;
//       });
//     }
//   };

//   const cleanupPrefetchedImages = (currentTargets) => {
//     setPrefetchedImages((prev) => {
//       const newMap = new Map();

//       [...prev.entries()].forEach(([imageName, imageUrl]) => {
//         if (currentTargets.includes(imageName) || imageName === selectedImage) {
//           newMap.set(imageName, imageUrl);
//         } else {
//           URL.revokeObjectURL(imageUrl);
//         }
//       });

//       return newMap;
//     });
//   };

//   const handleImageSelect = (imageName) => {
//     if (isImageLoading) return;
//     setSelectedImage(imageName);
//   };

//   const handleImageLoad = (e) => {
//     const img = e.target;
//     setImageSize({
//       width: img.naturalWidth,
//       height: img.naturalHeight,
//     });
//   };

//   const handleZoomIn = () => {
//     setScale((prev) => Math.min(prev + 0.25, 5));
//   };

//   const handleZoomOut = () => {
//     setScale((prev) => Math.max(prev - 0.25, 0.5));
//   };

//   const handleResetZoom = () => {
//     setScale(1);
//     setPosition({ x: 0, y: 0 });
//   };

//   const handleMouseDown = (e) => {
//     if (scale > 1) {
//       setIsDragging(true);
//       setDragStart({
//         x: e.clientX - position.x,
//         y: e.clientY - position.y,
//       });
//     }
//   };

//   const handleMouseMove = (e) => {
//     if (isDragging) {
//       setPosition({
//         x: e.clientX - dragStart.x,
//         y: e.clientY - dragStart.y,
//       });
//     }
//   };

//   const handleMouseUp = () => {
//     setIsDragging(false);
//   };

//   const handlePreviousImage = () => {
//     const currentIndex = filteredImages.findIndex(
//       (img) => img.filename === selectedImage
//     );
//     if (currentIndex > 0) {
//       const prevImage = filteredImages[currentIndex - 1];
//       setSelectedImage(prevImage.filename);

//       const prevPage = Math.ceil(currentIndex / itemsPerPage);
//       if (prevPage !== currentPage) {
//         setCurrentPage(prevPage);
//       }
//     }
//   };

//   const handleNextImage = () => {
//     const currentIndex = filteredImages.findIndex(
//       (img) => img.filename === selectedImage
//     );
//     if (currentIndex < filteredImages.length - 1) {
//       const nextImage = filteredImages[currentIndex + 1];
//       setSelectedImage(nextImage.filename);

//       const nextPage = Math.ceil((currentIndex + 2) / itemsPerPage);
//       if (nextPage !== currentPage) {
//         setCurrentPage(nextPage);
//       }
//     }
//   };

// useEffect(() => {
//   const handleKeyDown = (e) => {
//     // Check if Ctrl (or Cmd on Mac) is pressed
//     if (e.ctrlKey || e.metaKey) {
//       if (e.key === "ArrowLeft") {
//         e.preventDefault();
//         handlePreviousImage();
//       } else if (e.key === "ArrowRight") {
//         e.preventDefault();
//         handleNextImage();
//       } else if (e.key === "+" || e.key === "=") {
//         e.preventDefault();
//         handleZoomIn();
//       } else if (e.key === "-") {
//         e.preventDefault();
//         handleZoomOut();
//       } else if (e.key === "0") {
//         e.preventDefault();
//         handleResetZoom();
//       }
//     }
//   };

//   window.addEventListener("keydown", handleKeyDown);
//   return () => window.removeEventListener("keydown", handleKeyDown);
// }, [selectedImage, filteredImages]);

//   const totalPages = Math.ceil(filteredImages.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const endIndex = startIndex + itemsPerPage;
//   const currentImages = filteredImages.slice(startIndex, endIndex);

//   const handlePageChange = (newPage) => {
//     setCurrentPage(newPage);
//   };

//   const currentImageIndex = filteredImages.findIndex(
//     (img) => img.filename === selectedImage
//   );

//   return (
//     <div className="flex h-screen bg-gray-100 relative">
//       {notification.show && (
//         <div
//           className={`fixed top-4 right-4 p-4 rounded-lg shadow-lg z-50 transition-all duration-300 ${
//             notification.type === "success" ? "bg-green-500" : "bg-red-500"
//           } text-white`}
//         >
//           {notification.message}
//         </div>
//       )}

//       {/* Prefetch Status Indicator */}
//       {prefetchQueue.size > 0 && (
//         <div className="fixed bottom-4 right-4 bg-blue-100 border border-blue-300 rounded px-3 py-2 text-sm z-40">
//           Prefetching {prefetchQueue.size} image(s)...
//         </div>
//       )}

//       {/* Image List Sidebar */}
//       <div
//         className={`bg-white border-r border-gray-200 overflow-y-auto transition-all duration-300 ease-in-out ${
//           isSidebarCollapsed ? "w-0" : "w-1/4"
//         }`}
//         style={{ minWidth: isSidebarCollapsed ? "0" : "250px" }}
//       >
//         <div className={`p-4 ${isSidebarCollapsed ? "hidden" : "block"}`}>
//           <div className="mb-6">
//             <div className="flex items-center justify-between mb-4">
//               <div className="flex-1 min-w-0">
//                 <h2 className="text-xl font-semibold truncate">Batch Viewer</h2>
//                 <p className="text-sm text-gray-600 mt-1 truncate">
//                   {decodeURIComponent(batchName)}
//                 </p>
//                 {user && (
//                   <p className="text-xs text-gray-500 mt-1 truncate">
//                     {user.email}
//                   </p>
//                 )}
//               </div>
//               <div className="flex gap-2 ml-2">
//                 <button
//                   onClick={() => navigate("/")}
//                   className="flex items-center gap-2 px-3 py-2 text-sm bg-gray-500 hover:bg-gray-600 text-white rounded transition-colors"
//                   title="Back to Home"
//                 >
//                   <Home className="w-4 h-4" />
//                   <span className="hidden lg:inline">Home</span>
//                 </button>
   
//               </div>
//             </div>

//             <div className="mb-4">
//               <input
//                 type="text"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 placeholder="Search images..."
//                 className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
//               />
//             </div>
//           </div>

//           {isListLoading ? (
//             <div className="flex items-center justify-center p-4">
//               <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
//             </div>
//           ) : (
//             <>
//               <div className="space-y-2 mb-4">
//                 {currentImages.length > 0 ? (
//                   currentImages.map((image, index) => (
//                     <div
//                       key={image.filename}
//                       onClick={() => handleImageSelect(image.filename)}
//                       className={`group relative p-3 rounded-lg border transition-all duration-200 cursor-pointer ${
//                         selectedImage === image.filename
//                           ? "bg-blue-50 border-blue-500 shadow-md"
//                           : "border-gray-200 hover:border-blue-300 hover:bg-gray-50"
//                       }`}
//                     >
//                       <div className="flex justify-between items-start gap-2">
//                         <div className="relative flex-1 min-w-0">
//                           <p className="text-sm font-medium text-gray-700 break-all leading-tight">
//                             {startIndex + index + 1}. {image.filename}
//                           </p>
//                           {/* Prefetch indicator */}
//                           {prefetchedImages.has(image.filename) && (
//                             <span className="text-xs text-green-600 mt-1 block">
//                               ✓ Ready
//                             </span>
//                           )}
//                           <div className="absolute left-0 -top-2 transform -translate-y-full opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10">
//                             <div className="bg-gray-900 text-white px-3 py-2 rounded text-xs whitespace-normal break-words max-w-xs">
//                               {image.filename}
//                             </div>
//                             <div className="w-2 h-2 bg-gray-900 transform rotate-45 translate-x-2 translate-y-[-4px] ml-2"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   ))
//                 ) : (
//                   <div className="text-center py-8 text-gray-500">
//                     {searchTerm
//                       ? "No images match your search"
//                       : "No images in this batch"}
//                   </div>
//                 )}
//               </div>

//               {totalPages > 0 && (
//                 <div className="border-t border-gray-200 pt-4 space-y-3">
//                   <div className="flex items-center justify-between">
//                     <button
//                       onClick={() => handlePageChange(currentPage - 1)}
//                       disabled={currentPage === 1}
//                       className={`px-3 py-1 rounded ${
//                         currentPage === 1
//                           ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                           : "bg-blue-500 text-white hover:bg-blue-600"
//                       }`}
//                     >
//                       Previous
//                     </button>
//                     <span className="text-sm text-gray-600">
//                       Page {currentPage} of {totalPages}
//                     </span>
//                     <button
//                       onClick={() => handlePageChange(currentPage + 1)}
//                       disabled={currentPage === totalPages}
//                       className={`px-3 py-1 rounded ${
//                         currentPage === totalPages
//                           ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                           : "bg-blue-500 text-white hover:bg-blue-600"
//                       }`}
//                     >
//                       Next
//                     </button>
//                   </div>
//                   <div className="text-center">
//                     <span className="text-xs text-gray-500">
//                       {filteredImages.length} total images
//                     </span>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}
//         </div>
//       </div>

//       {/* Collapse/Expand Toggle Button */}
//       <button
//         onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
//         className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white border border-gray-300 rounded-r-lg p-2 hover:bg-gray-100 transition-all duration-300 shadow-md z-30"
//         style={{
//           left: isSidebarCollapsed ? "0" : "calc(25% - 1px)",
//           minWidth: "32px",
//         }}
//         title={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
//       >
//         {isSidebarCollapsed ? (
//           <ChevronRight className="w-5 h-5 text-gray-600" />
//         ) : (
//           <ChevronLeft className="w-5 h-5 text-gray-600" />
//         )}
//       </button>

//       {/* Image Viewer */}
//       <div
//         className={`flex-1 p-6 overflow-hidden flex flex-col transition-all duration-300 ${
//           isSidebarCollapsed ? "ml-0" : ""
//         }`}
//       >
//         {selectedImage ? (
//           <div className="bg-white rounded-lg shadow-lg p-6 flex flex-col h-full">
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-xl font-semibold truncate mr-4">
//                 {selectedImage}
//               </h2>
//               <div className="text-sm text-gray-600 whitespace-nowrap">
//                 Image {currentImageIndex + 1} of {filteredImages.length}
//               </div>
//             </div>

//             {/* Zoom Controls */}
//             <div className="flex justify-between items-center mb-4">
//               <div className="flex items-center gap-2">
//                 <button
//                   onClick={handleZoomOut}
//                   disabled={scale <= 0.5}
//                   className={`p-2 rounded ${
//                     scale <= 0.5
//                       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                       : "bg-blue-500 text-white hover:bg-blue-600"
//                   }`}
//                   title="Zoom Out (Ctrl+-)"
//                 >
//                   <ZoomOut className="w-5 h-5" />
//                 </button>
//                 <span className="text-sm font-medium min-w-[60px] text-center">
//                   {Math.round(scale * 100)}%
//                 </span>
//                 <button
//                   onClick={handleZoomIn}
//                   disabled={scale >= 5}
//                   className={`p-2 rounded ${
//                     scale >= 5
//                       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                       : "bg-blue-500 text-white hover:bg-blue-600"
//                   }`}
//                   title="Zoom In (Ctrl++)"
//                 >
//                   <ZoomIn className="w-5 h-5" />
//                 </button>
//                 <button
//                   onClick={handleResetZoom}
//                   className="p-2 bg-gray-500 text-white rounded hover:bg-gray-600"
//                   title="Reset Zoom (Ctrl+0)"
//                 >
//                   <Maximize2 className="w-5 h-5" />
//                 </button>
//               </div>

//               {/* Navigation Controls */}
//               <div className="flex items-center gap-2">
//                 <button
//                   onClick={handlePreviousImage}
//                   disabled={currentImageIndex === 0}
//                   className={`flex items-center gap-2 px-4 py-2 rounded ${
//                     currentImageIndex === 0
//                       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                       : "bg-blue-500 text-white hover:bg-blue-600"
//                   }`}
//                   title="Previous Image (Ctrl+←)"
//                 >
//                   <ArrowLeft className="w-4 h-4" />
//                   Previous
//                 </button>
//                 <button
//                   onClick={handleNextImage}
//                   disabled={currentImageIndex === filteredImages.length - 1}
//                   className={`flex items-center gap-2 px-4 py-2 rounded ${
//                     currentImageIndex === filteredImages.length - 1
//                       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                       : "bg-blue-500 text-white hover:bg-blue-600"
//                   }`}
//                   title="Next Image (Ctrl+→)"
//                 >
//                   Next
//                   <ArrowRight className="w-4 h-4" />
//                 </button>
//               </div>
//             </div>

//             {/* Image Container */}
//             <div
//               ref={containerRef}
//               className="relative flex-1 overflow-hidden bg-gray-50 rounded border border-gray-200"
//               onMouseDown={handleMouseDown}
//               onMouseMove={handleMouseMove}
//               onMouseUp={handleMouseUp}
//               onMouseLeave={handleMouseUp}
//               style={{
//                 cursor: isDragging
//                   ? "grabbing"
//                   : scale > 1
//                   ? "grab"
//                   : "default",
//               }}
//             >
//               {isImageLoading ? (
//                 <div className="flex items-center justify-center h-full">
//                   <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
//                 </div>
//               ) : (
//                 imageUrl && (
//                   <div className="w-full h-full flex items-center justify-center overflow-hidden">
//                     <img
//                       ref={imageRef}
//                       src={imageUrl}
//                       alt="Selected document"
//                       className="max-w-none"
//                       onLoad={handleImageLoad}
//                       style={{
//                         transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
//                         transition: isDragging
//                           ? "none"
//                           : "transform 0.2s ease-out",
//                         maxHeight: "100%",
//                         maxWidth: scale === 1 ? "100%" : "none",
//                         objectFit: "contain",
//                       }}
//                       draggable={false}
//                     />
//                   </div>
//                 )
//               )}
//             </div>


//         {/* Helper Text */}
// <div className="mt-4 text-center text-sm text-gray-500">
//   Use Ctrl+← / Ctrl+→ to navigate | Use Ctrl++/Ctrl+- to zoom | Press Ctrl+0
//   to reset zoom
//   {scale > 1 && " | Click and drag to pan"}
// </div>
//           </div>
//         ) : (
//           <div className="flex items-center justify-center h-full bg-white rounded-lg shadow-lg">
//             <p className="text-gray-500 text-lg">
//               {isListLoading
//                 ? "Loading images..."
//                 : "No images available in this batch"}
//             </p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default BatchImageViewer;


////adding res thing
// import React, { useState, useRef, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { useAuth } from "../AuthContext";
// import config from "../Components/Config/config";
// import {
//   ArrowLeft,
//   ArrowRight,
//   ZoomIn,
//   ZoomOut,
//   Maximize2,
//   Home,
//   ChevronLeft,
//   ChevronRight,
//   Sparkles,
//   Zap,
// } from "lucide-react";

// const BatchImageViewer = () => {
//   const navigate = useNavigate();
//   const { batchName } = useParams();
//   const { getToken, isAuthenticated, logout, user } = useAuth();

//   const [imageList, setImageList] = useState([]);
//   const [filteredImages, setFilteredImages] = useState([]);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [imageUrl, setImageUrl] = useState(null);
//   const [isListLoading, setIsListLoading] = useState(false);
//   const [isImageLoading, setIsImageLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [imageSize, setImageSize] = useState({ width: 0, height: 0 });
//   const [scale, setScale] = useState(1);
//   const [position, setPosition] = useState({ x: 0, y: 0 });
//   const [isDragging, setIsDragging] = useState(false);
//   const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
//   const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
//   const [isHighRes, setIsHighRes] = useState(false);

//   // Cache management - limit to prevent memory issues
//   const [prefetchedImages, setPrefetchedImages] = useState(new Map());
//   const [prefetchQueue, setPrefetchQueue] = useState(new Set());
//   const MAX_CACHE_SIZE = 10; // Maximum cached images (5 low-res + 5 high-res)
//   const CACHE_CLEANUP_THRESHOLD = 8; // Start cleanup at this threshold

//   const itemsPerPage = 10;
//   const imageRef = useRef(null);
//   const containerRef = useRef(null);
//   const loadingImageRef = useRef(null);

//   const [notification, setNotification] = useState({
//     show: false,
//     message: "",
//     type: "",
//   });

//   useEffect(() => {
//     if (!isAuthenticated()) {
//       navigate("/login");
//       return;
//     }

//     if (batchName) {
//       fetchImageList();
//     } else {
//       navigate("/");
//     }
//   }, [navigate, batchName, isAuthenticated]);

//   useEffect(() => {
//     const filtered = imageList.filter((image) =>
//       image.filename.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     const sortedFiltered = [...filtered].sort((a, b) =>
//       a.filename.localeCompare(b.filename)
//     );

//     setFilteredImages(sortedFiltered);
//     setCurrentPage(1);
//   }, [searchTerm, imageList]);

//   // Reset to low-res when image changes
//   useEffect(() => {
//     if (selectedImage) {
//       console.log("Selected image changed to:", selectedImage);
//       setIsHighRes(false);
//       loadImage(selectedImage, false);
//     }
//   }, [selectedImage]);

//   useEffect(() => {
//     setScale(1);
//     setPosition({ x: 0, y: 0 });
//   }, [imageUrl]);

//   // Smart cache cleanup
//   useEffect(() => {
//     if (prefetchedImages.size >= CACHE_CLEANUP_THRESHOLD) {
//       console.log(`Cache size: ${prefetchedImages.size}, running cleanup...`);
//       aggressiveCleanupCache();
//     }
//   }, [prefetchedImages.size]);

// // Prefetch logic - only prefetch low-res images AFTER main image loads
// useEffect(() => {
//   // Don't prefetch while main image is loading
//   if (!selectedImage || filteredImages.length === 0 || isImageLoading) {
//     return;
//   }

//   const currentIndex = filteredImages.findIndex(
//     (img) => img.filename === selectedImage
//   );
//   if (currentIndex === -1) return;

//   const imagesToPrefetch = [];

//   // Only prefetch next image (not previous) to save memory
//   if (currentIndex < filteredImages.length - 1) {
//     imagesToPrefetch.push(filteredImages[currentIndex + 1].filename);
//   }

//   // Cleanup old prefetched images
//   cleanupPrefetchedImages(imagesToPrefetch);

//   // Start prefetching (only low-res) with a delay to prioritize main image
//   imagesToPrefetch.forEach((imageName) => {
//     const cacheKey = `${imageName}_lowres`;
//     if (!prefetchedImages.has(cacheKey) && !prefetchQueue.has(cacheKey)) {
//       // Increased delay to ensure main image loads first
//       setTimeout(() => {
//         prefetchImage(imageName, false);
//       }, 500); // Increased from 100ms to 500ms
//     }
//   });
// }, [selectedImage, filteredImages, isImageLoading]); // Added isImageLoading dependency

//   // Cleanup on unmount
//   useEffect(() => {
//     return () => {
//       console.log("Component unmounting, cleaning up cache...");
//       prefetchedImages.forEach((imageUrl) => {
//         URL.revokeObjectURL(imageUrl);
//       });
//     };
//   }, []);

//   const showNotification = (message, type) => {
//     setNotification({ show: true, message, type });
//     setTimeout(() => {
//       setNotification({ show: false, message: "", type: "" });
//     }, 3000);
//   };

//   const aggressiveCleanupCache = () => {
//     setPrefetchedImages((prev) => {
//       const entries = Array.from(prev.entries());
//       const newMap = new Map();

//       // Keep only current image in both resolutions
//       const currentLowRes = `${selectedImage}_lowres`;
//       const currentHighRes = `${selectedImage}_highres`;

//       entries.forEach(([key, url]) => {
//         if (key === currentLowRes || key === currentHighRes) {
//           newMap.set(key, url);
//         } else {
//           URL.revokeObjectURL(url);
//           console.log("Revoked cache:", key);
//         }
//       });

//       console.log(`Cache cleaned: ${prev.size} → ${newMap.size} entries`);
//       return newMap;
//     });
//   };

//   const cleanupPrefetchedImages = (currentTargets) => {
//     if (prefetchedImages.size <= MAX_CACHE_SIZE) {
//       return; // No cleanup needed yet
//     }

//     setPrefetchedImages((prev) => {
//       const newMap = new Map();
//       const entries = Array.from(prev.entries());

//       // Priority: current image (both resolutions) + adjacent images (low-res only)
//       const keepKeys = new Set();
      
//       // Current image - both resolutions
//       keepKeys.add(`${selectedImage}_lowres`);
//       keepKeys.add(`${selectedImage}_highres`);
      
//       // Adjacent images - only low-res
//       currentTargets.forEach(name => {
//         keepKeys.add(`${name}_lowres`);
//       });

//       entries.forEach(([key, url]) => {
//         if (keepKeys.has(key)) {
//           newMap.set(key, url);
//         } else {
//           URL.revokeObjectURL(url);
//           console.log("Cleanup: revoked", key);
//         }
//       });

//       if (prev.size !== newMap.size) {
//         console.log(`Cache trimmed: ${prev.size} → ${newMap.size} entries`);
//       }

//       return newMap;
//     });
//   };

//   const handleLogout = () => {
//     logout();
//     navigate("/login");
//   };

//   const fetchImageList = async () => {
//     try {
//       setIsListLoading(true);
//       const token = getToken();

//       if (!token) {
//         navigate("/login");
//         return;
//       }

//       const url = `${config.API_BASE_URL}/api/batch_viewer/list_images/?batch_name=${encodeURIComponent(batchName)}`;

//       console.log("Fetching images from:", url);

//       const response = await fetch(url, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });

//       if (response.status === 401) {
//         showNotification("Session expired. Please login again.", "error");
//         logout();
//         navigate("/login");
//         return;
//       }

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error("Error fetching images:", errorText);
//         throw new Error(`Failed to fetch images: ${response.status}`);
//       }

//       const data = await response.json();
//       console.log("Images data:", data);

//       setImageList(data.images || []);

//       if (data.images && data.images.length > 0) {
//         setSelectedImage(data.images[0].filename);
//       }
//     } catch (error) {
//       console.error("Error fetching image list:", error);
//       showNotification("Failed to load images", "error");
//     } finally {
//       setIsListLoading(false);
//     }
//   };

//   const loadImage = async (imageName, highRes = false) => {
//     const loadKey = `${imageName}_${highRes ? 'highres' : 'lowres'}`;
    
//     if (loadingImageRef.current === loadKey) {
//       console.log("Already loading this image, skipping:", loadKey);
//       return;
//     }

//     try {
//       const cacheKey = `${imageName}_${highRes ? 'highres' : 'lowres'}`;
      
//       const prefetchedUrl = prefetchedImages.get(cacheKey);

//       if (prefetchedUrl) {
//         console.log(`Using cached image: ${imageName} (${highRes ? 'high-res' : 'low-res'})`);
//         setImageUrl(prefetchedUrl);
//         setIsImageLoading(false);
//         return;
//       }

//       console.log(`Loading image from server: ${imageName} (${highRes ? 'high-res' : 'low-res'})`);
      
//       loadingImageRef.current = loadKey;
//       setIsImageLoading(true);

//       const token = getToken();

//       if (!token) {
//         navigate("/login");
//         return;
//       }

//       const scaling = highRes ? 1.0 : 0.5;
//       const url = `${config.API_BASE_URL}/api/batch_viewer/get_image/?batch_name=${encodeURIComponent(batchName)}&image_name=${encodeURIComponent(imageName)}&scaling=${scaling}`;
//       console.log(`Fetching: ${url}`);

//       const response = await fetch(url, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//         },
//       });

//       if (response.status === 401) {
//         showNotification("Session expired. Please login again.", "error");
//         logout();
//         navigate("/login");
//         return;
//       }

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error("Error response:", errorText);
//         throw new Error(`Failed to load image: ${response.status} - ${errorText}`);
//       }

//       const contentType = response.headers.get('content-type');
//       console.log("Response content-type:", contentType);

//       if (!contentType || !contentType.startsWith('image/')) {
//         throw new Error(`Invalid content type: ${contentType}`);
//       }

//       const imageBlob = await response.blob();
//       console.log(`Image blob received - size: ${imageBlob.size} bytes, type: ${imageBlob.type}`);
      
//       if (imageBlob.size === 0) {
//         throw new Error("Received empty image blob");
//       }

//       const oldUrl = imageUrl;
//       if (oldUrl && !Array.from(prefetchedImages.values()).includes(oldUrl)) {
//         URL.revokeObjectURL(oldUrl);
//       }
      
//       const newImageUrl = URL.createObjectURL(imageBlob);
//       console.log(`Created blob URL: ${newImageUrl.substring(0, 50)}...`);
      
//       setImageUrl(newImageUrl);

//       // Add to cache
//       setPrefetchedImages((prev) => {
//         const newMap = new Map(prev);
//         newMap.set(cacheKey, newImageUrl);
        
//         // Trigger cleanup if cache is getting too large
//         if (newMap.size > MAX_CACHE_SIZE) {
//           console.log(`Cache overflow (${newMap.size}/${MAX_CACHE_SIZE}), cleanup needed`);
//         }
        
//         return newMap;
//       });
      
//       console.log(`Successfully loaded and cached: ${imageName} (${highRes ? 'high-res' : 'low-res'})`);
//     } catch (error) {
//       console.error("Error loading image:", error);
//       showNotification(`Failed to load image: ${error.message}`, "error");
//       setImageUrl(null);
//     } finally {
//       setIsImageLoading(false);
//       loadingImageRef.current = null;
//     }
//   };

//   const prefetchImage = async (imageName, highRes = false) => {
//     const cacheKey = `${imageName}_${highRes ? 'highres' : 'lowres'}`;
    
//     if (prefetchedImages.has(cacheKey) || prefetchQueue.has(cacheKey)) {
//       return;
//     }

//     // Don't prefetch if cache is near limit
//     if (prefetchedImages.size >= MAX_CACHE_SIZE - 1) {
//       console.log("Cache near limit, skipping prefetch");
//       return;
//     }

//     setPrefetchQueue((prev) => new Set([...prev, cacheKey]));

//     try {
//       const token = getToken();

//       if (!token) {
//         return;
//       }

//       const scaling = highRes ? 1.0 : 0.5;
//       const url = `${config.API_BASE_URL}/api/batch_viewer/get_image/?batch_name=${encodeURIComponent(batchName)}&image_name=${encodeURIComponent(imageName)}&scaling=${scaling}`;
//       console.log(`Prefetching: ${imageName} (${highRes ? 'high-res' : 'low-res'})`);

//       const response = await fetch(url, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//         },
//       });

//       if (response.status === 401) {
//         console.log("Token expired during prefetch");
//         return;
//       }

//       if (response.ok) {
//         const contentType = response.headers.get('content-type');
//         if (!contentType || !contentType.startsWith('image/')) {
//           console.error("Invalid content type in prefetch:", contentType);
//           return;
//         }

//         const imageBlob = await response.blob();
        
//         if (imageBlob.size === 0) {
//           console.error("Received empty blob in prefetch");
//           return;
//         }

//         const imageUrl = URL.createObjectURL(imageBlob);

//         setPrefetchedImages((prev) => {
//           const newMap = new Map(prev);
//           newMap.set(cacheKey, imageUrl);
//           return newMap;
//         });

//         console.log(`Prefetched: ${imageName} (${highRes ? 'high-res' : 'low-res'})`);
//       }
//     } catch (error) {
//       console.error(`Error prefetching ${imageName}:`, error);
//     } finally {
//       setPrefetchQueue((prev) => {
//         const newSet = new Set(prev);
//         newSet.delete(cacheKey);
//         return newSet;
//       });
//     }
//   };

//   const handleImageSelect = (imageName) => {
//     if (isImageLoading) return;
//     setSelectedImage(imageName);
//   };

//   const handleImageLoad = (e) => {
//     const img = e.target;
//     setImageSize({
//       width: img.naturalWidth,
//       height: img.naturalHeight,
//     });
//     console.log("Image loaded successfully:", img.naturalWidth, "x", img.naturalHeight);
//   };

//   const handleImageError = (e) => {
//     console.error("Image failed to load in <img> tag:", e);
//     showNotification("Failed to display image", "error");
//   };

//   const handleZoomIn = () => {
//     setScale((prev) => Math.min(prev + 0.25, 5));
//   };

//   const handleZoomOut = () => {
//     setScale((prev) => Math.max(prev - 0.25, 0.5));
//   };

//   const handleResetZoom = () => {
//     setScale(1);
//     setPosition({ x: 0, y: 0 });
//   };

//   const toggleHighRes = () => {
//     if (isImageLoading) {
//       console.log("Already loading, ignoring toggle");
//       return;
//     }

//     const newHighRes = !isHighRes;
//     console.log(`Toggling resolution: ${isHighRes ? 'high' : 'low'} → ${newHighRes ? 'high' : 'low'}`);
    
//     setIsHighRes(newHighRes);
    
//     if (selectedImage) {
//       showNotification(
//         newHighRes ? "Switching to high res..." : "Switching to low res...",
//         "success"
//       );
      
//       loadImage(selectedImage, newHighRes);
//     }
//   };

//   const handleMouseDown = (e) => {
//     if (scale > 1) {
//       setIsDragging(true);
//       setDragStart({
//         x: e.clientX - position.x,
//         y: e.clientY - position.y,
//       });
//     }
//   };

//   const handleMouseMove = (e) => {
//     if (isDragging) {
//       setPosition({
//         x: e.clientX - dragStart.x,
//         y: e.clientY - dragStart.y,
//       });
//     }
//   };

//   const handleMouseUp = () => {
//     setIsDragging(false);
//   };

//   const handlePreviousImage = () => {
//     const currentIndex = filteredImages.findIndex(
//       (img) => img.filename === selectedImage
//     );
//     if (currentIndex > 0) {
//       const prevImage = filteredImages[currentIndex - 1];
//       setSelectedImage(prevImage.filename);

//       const prevPage = Math.ceil(currentIndex / itemsPerPage);
//       if (prevPage !== currentPage) {
//         setCurrentPage(prevPage);
//       }
//     }
//   };

//   const handleNextImage = () => {
//     const currentIndex = filteredImages.findIndex(
//       (img) => img.filename === selectedImage
//     );
//     if (currentIndex < filteredImages.length - 1) {
//       const nextImage = filteredImages[currentIndex + 1];
//       setSelectedImage(nextImage.filename);

//       const nextPage = Math.ceil((currentIndex + 2) / itemsPerPage);
//       if (nextPage !== currentPage) {
//         setCurrentPage(nextPage);
//       }
//     }
//   };

//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.ctrlKey || e.metaKey) {
//         if (e.key === "ArrowLeft") {
//           e.preventDefault();
//           handlePreviousImage();
//         } else if (e.key === "ArrowRight") {
//           e.preventDefault();
//           handleNextImage();
//         } else if (e.key === "+" || e.key === "=") {
//           e.preventDefault();
//           handleZoomIn();
//         } else if (e.key === "-") {
//           e.preventDefault();
//           handleZoomOut();
//         } else if (e.key === "0") {
//           e.preventDefault();
//           handleResetZoom();
//         } else if (e.key === "h" || e.key === "H") {
//           e.preventDefault();
//           toggleHighRes();
//         }
//       }
//     };

//     window.addEventListener("keydown", handleKeyDown);
//     return () => window.removeEventListener("keydown", handleKeyDown);
//   }, [selectedImage, filteredImages, isHighRes, isImageLoading]);

//   const totalPages = Math.ceil(filteredImages.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const endIndex = startIndex + itemsPerPage;
//   const currentImages = filteredImages.slice(startIndex, endIndex);

//   const handlePageChange = (newPage) => {
//     setCurrentPage(newPage);
//   };

//   const currentImageIndex = filteredImages.findIndex(
//     (img) => img.filename === selectedImage
//   );

//   return (
//     <div className="flex h-screen bg-gray-100 relative">
//       {notification.show && (
//         <div
//           className={`fixed top-4 right-4 p-4 rounded-lg shadow-lg z-50 transition-all duration-300 ${
//             notification.type === "success" ? "bg-green-500" : "bg-red-500"
//           } text-white`}
//         >
//           {notification.message}
//         </div>
//       )}

//       {/* Cache Status Indicator (Debug) */}
//       {/* {prefetchedImages.size > 5 && (
//         <div className="fixed bottom-20 right-4 bg-yellow-100 border border-yellow-300 rounded px-3 py-2 text-xs z-40">
//           Cache: {prefetchedImages.size}/{MAX_CACHE_SIZE}
//         </div>
//       )} */}

//       {/* Prefetch Status Indicator */}
//       {/* {prefetchQueue.size > 0 && (
//         <div className="fixed bottom-4 right-4 bg-blue-100 border border-blue-300 rounded px-3 py-2 text-sm z-40">
//           Loading {prefetchQueue.size} image(s)...
//         </div>
//       )} */}

//       {/* Image List Sidebar */}
//       <div
//         className={`bg-white border-r border-gray-200 overflow-y-auto transition-all duration-300 ease-in-out ${
//           isSidebarCollapsed ? "w-0" : "w-1/4"
//         }`}
//         style={{ minWidth: isSidebarCollapsed ? "0" : "250px" }}
//       >
//         <div className={`p-4 ${isSidebarCollapsed ? "hidden" : "block"}`}>
//           <div className="mb-6">
//             <div className="flex items-center justify-between mb-4">
//               <div className="flex-1 min-w-0">
//                 <h2 className="text-xl font-semibold truncate">Batch Viewer</h2>
//                 <p className="text-sm text-gray-600 mt-1 truncate">
//                   {decodeURIComponent(batchName)}
//                 </p>
//                 {user && (
//                   <p className="text-xs text-gray-500 mt-1 truncate">
//                     {user.email}
//                   </p>
//                 )}
//               </div>
//               <div className="flex gap-2 ml-2">
//                 <button
//                   onClick={() => navigate("/")}
//                   className="flex items-center gap-2 px-3 py-2 text-sm bg-gray-500 hover:bg-gray-600 text-white rounded transition-colors"
//                   title="Back to Home"
//                 >
//                   <Home className="w-4 h-4" />
//                   <span className="hidden lg:inline">Home</span>
//                 </button>
//               </div>
//             </div>

//             <div className="mb-4">
//               <input
//                 type="text"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 placeholder="Search images..."
//                 className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
//               />
//             </div>
//           </div>

//           {isListLoading ? (
//             <div className="flex items-center justify-center p-4">
//               <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
//             </div>
//           ) : (
//             <>
//               <div className="space-y-2 mb-4">
//                 {currentImages.length > 0 ? (
//                   currentImages.map((image, index) => (
//                     <div
//                       key={image.filename}
//                       onClick={() => handleImageSelect(image.filename)}
//                       className={`group relative p-3 rounded-lg border transition-all duration-200 cursor-pointer ${
//                         selectedImage === image.filename
//                           ? "bg-blue-50 border-blue-500 shadow-md"
//                           : "border-gray-200 hover:border-blue-300 hover:bg-gray-50"
//                       }`}
//                     >
//                       <div className="flex justify-between items-start gap-2">
//                         <div className="relative flex-1 min-w-0">
//                           <p className="text-sm font-medium text-gray-700 break-all leading-tight">
//                             {startIndex + index + 1}. {image.filename}
//                           </p>
//                           {prefetchedImages.has(`${image.filename}_lowres`) && (
//                             <span className="text-xs text-green-600 mt-1 block">
//                               ✓ Ready
//                             </span>
//                           )}
//                           <div className="absolute left-0 -top-2 transform -translate-y-full opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10">
//                             <div className="bg-gray-900 text-white px-3 py-2 rounded text-xs whitespace-normal break-words max-w-xs">
//                               {image.filename}
//                             </div>
//                             <div className="w-2 h-2 bg-gray-900 transform rotate-45 translate-x-2 translate-y-[-4px] ml-2"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   ))
//                 ) : (
//                   <div className="text-center py-8 text-gray-500">
//                     {searchTerm
//                       ? "No images match your search"
//                       : "No images in this batch"}
//                   </div>
//                 )}
//               </div>

//               {totalPages > 0 && (
//                 <div className="border-t border-gray-200 pt-4 space-y-3">
//                   <div className="flex items-center justify-between">
//                     <button
//                       onClick={() => handlePageChange(currentPage - 1)}
//                       disabled={currentPage === 1}
//                       className={`px-3 py-1 rounded ${
//                         currentPage === 1
//                           ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                           : "bg-blue-500 text-white hover:bg-blue-600"
//                       }`}
//                     >
//                       Previous
//                     </button>
//                     <span className="text-sm text-gray-600">
//                       Page {currentPage} of {totalPages}
//                     </span>
//                     <button
//                       onClick={() => handlePageChange(currentPage + 1)}
//                       disabled={currentPage === totalPages}
//                       className={`px-3 py-1 rounded ${
//                         currentPage === totalPages
//                           ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                           : "bg-blue-500 text-white hover:bg-blue-600"
//                       }`}
//                     >
//                       Next
//                     </button>
//                   </div>
//                   <div className="text-center">
//                     <span className="text-xs text-gray-500">
//                       {filteredImages.length} total images
//                     </span>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}
//         </div>
//       </div>

//       {/* Collapse/Expand Toggle Button */}
//       <button
//         onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
//         className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white border border-gray-300 rounded-r-lg p-2 hover:bg-gray-100 transition-all duration-300 shadow-md z-30"
//         style={{
//           left: isSidebarCollapsed ? "0" : "calc(25% - 1px)",
//           minWidth: "32px",
//         }}
//         title={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
//       >
//         {isSidebarCollapsed ? (
//           <ChevronRight className="w-5 h-5 text-gray-600" />
//         ) : (
//           <ChevronLeft className="w-5 h-5 text-gray-600" />
//         )}
//       </button>

//       {/* Image Viewer */}
//       <div
//         className={`flex-1 p-6 overflow-hidden flex flex-col transition-all duration-300 ${
//           isSidebarCollapsed ? "ml-0" : ""
//         }`}
//       >
//         {selectedImage ? (
//           <div className="bg-white rounded-lg shadow-lg p-6 flex flex-col h-full">
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-xl font-semibold truncate mr-4">
//                 {selectedImage}
//               </h2>
//               <div className="flex items-center gap-3">
//                 <div className="text-sm text-gray-600 whitespace-nowrap">
//                   Image {currentImageIndex + 1} of {filteredImages.length}
//                 </div>
//               </div>
//             </div>

//             {/* Controls */}
//             <div className="flex justify-between items-center mb-4 gap-4">
//               {/* Zoom Controls */}
//               <div className="flex items-center gap-2">
//                 <button
//                   onClick={handleZoomOut}
//                   disabled={scale <= 0.5}
//                   className={`p-2 rounded ${
//                     scale <= 0.5
//                       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                       : "bg-blue-500 text-white hover:bg-blue-600"
//                   }`}
//                   title="Zoom Out (Ctrl+-)"
//                 >
//                   <ZoomOut className="w-5 h-5" />
//                 </button>
//                 <span className="text-sm font-medium min-w-[60px] text-center">
//                   {Math.round(scale * 100)}%
//                 </span>
//                 <button
//                   onClick={handleZoomIn}
//                   disabled={scale >= 5}
//                   className={`p-2 rounded ${
//                     scale >= 5
//                       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                       : "bg-blue-500 text-white hover:bg-blue-600"
//                   }`}
//                   title="Zoom In (Ctrl++)"
//                 >
//                   <ZoomIn className="w-5 h-5" />
//                 </button>
//                 <button
//                   onClick={handleResetZoom}
//                   className="p-2 bg-gray-500 text-white rounded hover:bg-gray-600"
//                   title="Reset Zoom (Ctrl+0)"
//                 >
//                   <Maximize2 className="w-5 h-5" />
//                 </button>
//               </div>

//               {/* Quality Toggle - IMPROVED DESIGN */}
//               <div className="flex items-center gap-2 bg-gray-100 rounded-lg p-1">
//                 <button
//                   onClick={toggleHighRes}
//                   disabled={isImageLoading}
//                   className={`flex items-center gap-2 px-4 py-2 rounded-md font-medium transition-all duration-200 ${
//                     isImageLoading
//                       ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                       : !isHighRes
//                       ? "bg-white text-blue-600 shadow-sm"
//                       : "text-gray-600 hover:text-gray-800"
//                   }`}
//                   title="Low Res - Lower quality, faster loading (Ctrl+H)"
//                 >
//                   <Zap className="w-4 h-4" />
//                   <span className="text-sm">Low-res</span>
//                 </button>
                
//                 <button
//                   onClick={toggleHighRes}
//                   disabled={isImageLoading}
//                   className={`flex items-center gap-2 px-4 py-2 rounded-md font-medium transition-all duration-200 ${
//                     isImageLoading
//                       ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                       : isHighRes
//                       ? "bg-white text-purple-600 shadow-sm"
//                       : "text-gray-600 hover:text-gray-800"
//                   }`}
//                   title="High Res  - Full resolution, slower loading (Ctrl+H)"
//                 >
//                   <Sparkles className="w-4 h-4" />
//                   <span className="text-sm">High-res</span>
//                 </button>
//               </div>

//               {/* Navigation Controls */}
//               <div className="flex items-center gap-2">
//                 <button
//                   onClick={handlePreviousImage}
//                   disabled={currentImageIndex === 0}
//                   className={`flex items-center gap-2 px-4 py-2 rounded ${
//                     currentImageIndex === 0
//                       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                       : "bg-blue-500 text-white hover:bg-blue-600"
//                   }`}
//                   title="Previous Image (Ctrl+←)"
//                 >
//                   <ArrowLeft className="w-4 h-4" />
//                   Previous
//                 </button>
//                 <button
//                   onClick={handleNextImage}
//                   disabled={currentImageIndex === filteredImages.length - 1}
//                   className={`flex items-center gap-2 px-4 py-2 rounded ${
//                     currentImageIndex === filteredImages.length - 1
//                       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                       : "bg-blue-500 text-white hover:bg-blue-600"
//                   }`}
//                   title="Next Image (Ctrl+→)"
//                 >
//                   Next
//                   <ArrowRight className="w-4 h-4" />
//                 </button>
//               </div>
//             </div>

//             {/* Image Container */}
//             <div
//               ref={containerRef}
//               className="relative flex-1 overflow-hidden bg-gray-50 rounded border border-gray-200"
//               onMouseDown={handleMouseDown}
//               onMouseMove={handleMouseMove}
//               onMouseUp={handleMouseUp}
//               onMouseLeave={handleMouseUp}
//               style={{
//                 cursor: isDragging
//                   ? "grabbing"
//                   : scale > 1
//                   ? "grab"
//                   : "default",
//               }}
//             >
//               {isImageLoading ? (
//                 <div className="flex items-center justify-center h-full">
//                   <div className="text-center">
//                     <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-2"></div>
//                     <p className="text-sm text-gray-600">
//                       Loading {isHighRes ? "High Res" : "Low Res"} mode...
//                     </p>
//                   </div>
//                 </div>
//               ) : imageUrl ? (
//                 <div className="w-full h-full flex items-center justify-center overflow-hidden">
//                   <img
//                     ref={imageRef}
//                     src={imageUrl}
//                     alt={selectedImage}
//                     className="max-w-none"
//                     onLoad={handleImageLoad}
//                     onError={handleImageError}
//                     style={{
//                       transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
//                       transition: isDragging
//                         ? "none"
//                         : "transform 0.2s ease-out",
//                       maxHeight: "100%",
//                       maxWidth: scale === 1 ? "100%" : "none",
//                       objectFit: "contain",
//                     }}
//                     draggable={false}
//                   />
//                 </div>
//               ) : (
//                 <div className="flex items-center justify-center h-full">
//                   <p className="text-gray-500">No image loaded</p>
//                 </div>
//               )}
//             </div>

//             {/* Helper Text */}
//             <div className="mt-4 text-center text-sm text-gray-500">
//               <span className="font-medium">
//               </span>
//               {" • "}
//               Use Ctrl+← / Ctrl+→ to navigate
//               {" • "}
//               Ctrl++ / Ctrl+- to zoom
//               {" • "}
//               Ctrl+H to toggle mode
//               {scale > 1 && " • Drag to pan"}
//             </div>
//           </div>
//         ) : (
//           <div className="flex items-center justify-center h-full bg-white rounded-lg shadow-lg">
//             <p className="text-gray-500 text-lg">
//               {isListLoading
//                 ? "Loading images..."
//                 : "No images available in this batch"}
//             </p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default BatchImageViewer;



///////////prefetching logic improved version below///////////
// import React, { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { useAuth } from "../AuthContext";
// import config from "../Components/Config/config";

// import { ChevronLeft, ChevronRight } from "lucide-react";
// import ImageList from "./ImageList";
// import ImageDisplay from "./ImageView";

// const BatchImageViewer = () => {
//   const navigate = useNavigate();
//   const { batchName } = useParams();
//   const { getToken, isAuthenticated, logout, user } = useAuth();

//   // State management
//   const [imageList, setImageList] = useState([]);
//   const [filteredImages, setFilteredImages] = useState([]);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [imageUrl, setImageUrl] = useState(null);
//   const [isListLoading, setIsListLoading] = useState(false);
//   const [isImageLoading, setIsImageLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
//   const [isHighRes, setIsHighRes] = useState(false);
//   const [notification, setNotification] = useState({
//     show: false,
//     message: "",
//     type: "",
//   });

//   // Cache management
//   const [prefetchedImages, setPrefetchedImages] = useState(new Map());
//   const [prefetchQueue, setPrefetchQueue] = useState(new Set());
//   const MAX_CACHE_SIZE = 10;
//   const CACHE_CLEANUP_THRESHOLD = 8;

//   const itemsPerPage = 10;
//   const loadingImageRef = React.useRef(null);

//   // Get image scaling from localStorage
//   const getImageScaling = () => {
//     const savedScaling = localStorage.getItem("imageScaling");
//     if (savedScaling) {
//       const scalingValue = parseFloat(savedScaling);
//       if (!isNaN(scalingValue) && scalingValue >= 0.1 && scalingValue <= 1.0) {
//         return scalingValue;
//       }
//     }
//     return 0.5;
//   };

//   // Authentication check
//   useEffect(() => {
//     if (!isAuthenticated()) {
//       navigate("/login");
//       return;
//     }

//     if (batchName) {
//       fetchImageList();
//     } else {
//       navigate("/");
//     }
//   }, [navigate, batchName, isAuthenticated]);

//   // Filter images based on search
//   useEffect(() => {
//     const filtered = imageList.filter((image) =>
//       image.filename.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     const sortedFiltered = [...filtered].sort((a, b) =>
//       a.filename.localeCompare(b.filename)
//     );

//     setFilteredImages(sortedFiltered);
//     setCurrentPage(1);
//   }, [searchTerm, imageList]);

//   // Reset to low-res when image changes
//   useEffect(() => {
//     if (selectedImage) {
//       console.log("Selected image changed to:", selectedImage);
//       setIsHighRes(false);
//       loadImage(selectedImage, false);
//     }
//   }, [selectedImage]);

//   // Smart cache cleanup
//   useEffect(() => {
//     if (prefetchedImages.size >= CACHE_CLEANUP_THRESHOLD) {
//       console.log(`Cache size: ${prefetchedImages.size}, running cleanup...`);
//       aggressiveCleanupCache();
//     }
//   }, [prefetchedImages.size]);

//   // Prefetch logic
//   useEffect(() => {
//     if (!selectedImage || filteredImages.length === 0 || isImageLoading) {
//       return;
//     }

//     const currentIndex = filteredImages.findIndex(
//       (img) => img.filename === selectedImage
//     );
//     if (currentIndex === -1) return;

//     const imagesToPrefetch = [];

//     if (currentIndex < filteredImages.length - 1) {
//       imagesToPrefetch.push(filteredImages[currentIndex + 1].filename);
//     }

//     const prefetchTimeout = setTimeout(() => {
//       console.log("Main image loaded, starting prefetch...");
//       cleanupPrefetchedImages(imagesToPrefetch);
      
//       imagesToPrefetch.forEach((imageName) => {
//         const cacheKey = `${imageName}_lowres`;
//         if (!prefetchedImages.has(cacheKey) && !prefetchQueue.has(cacheKey)) {
//           prefetchImage(imageName, false);
//         }
//       });
//     }, 1000);

//     return () => clearTimeout(prefetchTimeout);
//   }, [selectedImage, filteredImages, isImageLoading]);

//   // Cleanup on unmount
//   useEffect(() => {
//     return () => {
//       console.log("Component unmounting, cleaning up cache...");
//       prefetchedImages.forEach((imageUrl) => {
//         URL.revokeObjectURL(imageUrl);
//       });
//     };
//   }, []);

//   const showNotification = (message, type) => {
//     setNotification({ show: true, message, type });
//     setTimeout(() => {
//       setNotification({ show: false, message: "", type: "" });
//     }, 3000);
//   };

//   const aggressiveCleanupCache = () => {
//     setPrefetchedImages((prev) => {
//       const entries = Array.from(prev.entries());
//       const newMap = new Map();

//       const currentLowRes = `${selectedImage}_lowres`;
//       const currentHighRes = `${selectedImage}_highres`;

//       entries.forEach(([key, url]) => {
//         if (key === currentLowRes || key === currentHighRes) {
//           newMap.set(key, url);
//         } else {
//           URL.revokeObjectURL(url);
//           console.log("Revoked cache:", key);
//         }
//       });

//       console.log(`Cache cleaned: ${prev.size} → ${newMap.size} entries`);
//       return newMap;
//     });
//   };

//   const cleanupPrefetchedImages = (currentTargets) => {
//     if (prefetchedImages.size <= MAX_CACHE_SIZE) {
//       return;
//     }

//     setPrefetchedImages((prev) => {
//       const newMap = new Map();
//       const entries = Array.from(prev.entries());

//       const keepKeys = new Set();
//       keepKeys.add(`${selectedImage}_lowres`);
//       keepKeys.add(`${selectedImage}_highres`);
      
//       currentTargets.forEach(name => {
//         keepKeys.add(`${name}_lowres`);
//       });

//       entries.forEach(([key, url]) => {
//         if (keepKeys.has(key)) {
//           newMap.set(key, url);
//         } else {
//           URL.revokeObjectURL(url);
//           console.log("Cleanup: revoked", key);
//         }
//       });

//       if (prev.size !== newMap.size) {
//         console.log(`Cache trimmed: ${prev.size} → ${newMap.size} entries`);
//       }

//       return newMap;
//     });
//   };

//   const handleLogout = () => {
//     logout();
//     navigate("/login");
//   };

//   const fetchImageList = async () => {
//     try {
//       setIsListLoading(true);
//       const token = getToken();

//       if (!token) {
//         navigate("/login");
//         return;
//       }

//       const url = `${config.API_BASE_URL}/api/batch_viewer/list_images/?batch_name=${encodeURIComponent(batchName)}`;

//       console.log("Fetching images from:", url);

//       const response = await fetch(url, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });

//       if (response.status === 401) {
//         showNotification("Session expired. Please login again.", "error");
//         logout();
//         navigate("/login");
//         return;
//       }

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error("Error fetching images:", errorText);
//         throw new Error(`Failed to fetch images: ${response.status}`);
//       }

//       const data = await response.json();
//       console.log("Images data:", data);

//       setImageList(data.images || []);

//       if (data.images && data.images.length > 0) {
//         setSelectedImage(data.images[0].filename);
//       }
//     } catch (error) {
//       console.error("Error fetching image list:", error);
//       showNotification("Failed to load images", "error");
//     } finally {
//       setIsListLoading(false);
//     }
//   };

//   const loadImage = async (imageName, highRes = false) => {
//     const loadKey = `${imageName}_${highRes ? 'highres' : 'lowres'}`;
    
//     if (loadingImageRef.current === loadKey) {
//       console.log("Already loading this image, skipping:", loadKey);
//       return;
//     }

//     try {
//       const cacheKey = `${imageName}_${highRes ? 'highres' : 'lowres'}`;
//       const prefetchedUrl = prefetchedImages.get(cacheKey);

//       if (prefetchedUrl) {
//         console.log(`Using cached image: ${imageName} (${highRes ? 'high-res' : 'low-res'})`);
//         setImageUrl(prefetchedUrl);
//         setIsImageLoading(false);
//         return;
//       }

//       console.log(`Loading image from server: ${imageName} (${highRes ? 'high-res' : 'low-res'})`);
      
//       loadingImageRef.current = loadKey;
//       setIsImageLoading(true);

//       const token = getToken();

//       if (!token) {
//         navigate("/login");
//         return;
//       }

//       const scaling = highRes ? 1.0 : getImageScaling();
//       const url = `${config.API_BASE_URL}/api/batch_viewer/get_image/?batch_name=${encodeURIComponent(batchName)}&image_name=${encodeURIComponent(imageName)}&scaling=${scaling}`;
//       console.log(`Fetching: ${url} (scaling: ${scaling})`);

//       const response = await fetch(url, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//         },
//       });

//       if (response.status === 401) {
//         showNotification("Session expired. Please login again.", "error");
//         logout();
//         navigate("/login");
//         return;
//       }

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error("Error response:", errorText);
//         throw new Error(`Failed to load image: ${response.status} - ${errorText}`);
//       }

//       const contentType = response.headers.get('content-type');
//       console.log("Response content-type:", contentType);

//       if (!contentType || !contentType.startsWith('image/')) {
//         throw new Error(`Invalid content type: ${contentType}`);
//       }

//       const imageBlob = await response.blob();
//       console.log(`Image blob received - size: ${imageBlob.size} bytes, type: ${imageBlob.type}`);
      
//       if (imageBlob.size === 0) {
//         throw new Error("Received empty image blob");
//       }

//       const oldUrl = imageUrl;
//       if (oldUrl && !Array.from(prefetchedImages.values()).includes(oldUrl)) {
//         URL.revokeObjectURL(oldUrl);
//       }
      
//       const newImageUrl = URL.createObjectURL(imageBlob);
//       console.log(`Created blob URL: ${newImageUrl.substring(0, 50)}...`);
      
//       setImageUrl(newImageUrl);

//       setPrefetchedImages((prev) => {
//         const newMap = new Map(prev);
//         newMap.set(cacheKey, newImageUrl);
        
//         if (newMap.size > MAX_CACHE_SIZE) {
//           console.log(`Cache overflow (${newMap.size}/${MAX_CACHE_SIZE}), cleanup needed`);
//         }
        
//         return newMap;
//       });
      
//       console.log(`Successfully loaded and cached: ${imageName} (${highRes ? 'high-res' : 'low-res'})`);
//     } catch (error) {
//       console.error("Error loading image:", error);
//       showNotification(`Failed to load image: ${error.message}`, "error");
//       setImageUrl(null);
//     } finally {
//       setIsImageLoading(false);
//       loadingImageRef.current = null;
//     }
//   };

//   const prefetchImage = async (imageName, highRes = false) => {
//     const cacheKey = `${imageName}_${highRes ? 'highres' : 'lowres'}`;
    
//     if (prefetchedImages.has(cacheKey) || prefetchQueue.has(cacheKey)) {
//       return;
//     }

//     if (prefetchedImages.size >= MAX_CACHE_SIZE - 1) {
//       console.log("Cache near limit, skipping prefetch");
//       return;
//     }

//     setPrefetchQueue((prev) => new Set([...prev, cacheKey]));

//     try {
//       const token = getToken();

//       if (!token) {
//         return;
//       }

//       const scaling = highRes ? 1.0 : getImageScaling();
//       const url = `${config.API_BASE_URL}/api/batch_viewer/get_image/?batch_name=${encodeURIComponent(batchName)}&image_name=${encodeURIComponent(imageName)}&scaling=${scaling}`;
//       console.log(`Prefetching: ${imageName} (${highRes ? 'high-res' : 'low-res'}) with scaling ${scaling}`);

//       const response = await fetch(url, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//         },
//       });

//       if (response.status === 401) {
//         console.log("Token expired during prefetch");
//         return;
//       }

//       if (response.ok) {
//         const contentType = response.headers.get('content-type');
//         if (!contentType || !contentType.startsWith('image/')) {
//           console.error("Invalid content type in prefetch:", contentType);
//           return;
//         }

//         const imageBlob = await response.blob();
        
//         if (imageBlob.size === 0) {
//           console.error("Received empty blob in prefetch");
//           return;
//         }

//         const imageUrl = URL.createObjectURL(imageBlob);

//         setPrefetchedImages((prev) => {
//           const newMap = new Map(prev);
//           newMap.set(cacheKey, imageUrl);
//           return newMap;
//         });

//         console.log(`Prefetched: ${imageName} (${highRes ? 'high-res' : 'low-res'})`);
//       }
//     } catch (error) {
//       console.error(`Error prefetching ${imageName}:`, error);
//     } finally {
//       setPrefetchQueue((prev) => {
//         const newSet = new Set(prev);
//         newSet.delete(cacheKey);
//         return newSet;
//       });
//     }
//   };

//   const handleImageSelect = (imageName) => {
//     if (isImageLoading) return;
//     setSelectedImage(imageName);
//   };

//   const handlePreviousImage = () => {
//     const currentIndex = filteredImages.findIndex(
//       (img) => img.filename === selectedImage
//     );
//     if (currentIndex > 0) {
//       const prevImage = filteredImages[currentIndex - 1];
//       setSelectedImage(prevImage.filename);

//       const prevPage = Math.ceil(currentIndex / itemsPerPage);
//       if (prevPage !== currentPage) {
//         setCurrentPage(prevPage);
//       }
//     }
//   };

//   const handleNextImage = () => {
//     const currentIndex = filteredImages.findIndex(
//       (img) => img.filename === selectedImage
//     );
//     if (currentIndex < filteredImages.length - 1) {
//       const nextImage = filteredImages[currentIndex + 1];
//       setSelectedImage(nextImage.filename);

//       const nextPage = Math.ceil((currentIndex + 2) / itemsPerPage);
//       if (nextPage !== currentPage) {
//         setCurrentPage(nextPage);
//       }
//     }
//   };

//   const handlePageChange = (newPage) => {
//     setCurrentPage(newPage);
//   };

//   const currentImageIndex = filteredImages.findIndex(
//     (img) => img.filename === selectedImage
//   );

//   return (
//     <div className="flex h-screen bg-gray-100 relative">
//       {notification.show && (
//         <div
//           className={`fixed top-4 right-4 p-4 rounded-lg shadow-lg z-50 transition-all duration-300 ${
//             notification.type === "success" ? "bg-green-500" : "bg-red-500"
//           } text-white`}
//         >
//           {notification.message}
//         </div>
//       )}

//       {/* Image List Sidebar */}
//       <ImageList
//         isSidebarCollapsed={isSidebarCollapsed}
//         batchName={batchName}
//         user={user}
//         navigate={navigate}
//         searchTerm={searchTerm}
//         setSearchTerm={setSearchTerm}
//         isListLoading={isListLoading}
//         filteredImages={filteredImages}
//         currentPage={currentPage}
//         itemsPerPage={itemsPerPage}
//         selectedImage={selectedImage}
//         handleImageSelect={handleImageSelect}
//         prefetchedImages={prefetchedImages}
//         handlePageChange={handlePageChange}
//       />

//       {/* Collapse/Expand Toggle Button */}
//       <button
//         onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
//         className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white border border-gray-300 rounded-r-lg p-2 hover:bg-gray-100 transition-all duration-300 shadow-md z-30"
//         style={{
//           left: isSidebarCollapsed ? "0" : "calc(25% - 1px)",
//           minWidth: "32px",
//         }}
//         title={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
//       >
//         {isSidebarCollapsed ? (
//           <ChevronRight className="w-5 h-5 text-gray-600" />
//         ) : (
//           <ChevronLeft className="w-5 h-5 text-gray-600" />
//         )}
//       </button>

//       {/* Image Display */}
//       <ImageDisplay
//         isSidebarCollapsed={isSidebarCollapsed}
//         selectedImage={selectedImage}
//         imageUrl={imageUrl}
//         setImageUrl={setImageUrl}
//         isImageLoading={isImageLoading}
//         isHighRes={isHighRes}
//         setIsHighRes={setIsHighRes}
//         filteredImages={filteredImages}
//         currentImageIndex={currentImageIndex}
//         loadImage={loadImage}
//         showNotification={showNotification}
//         isListLoading={isListLoading}
//         onNavigatePrevious={handlePreviousImage}
//         onNavigateNext={handleNextImage}
//       />
//     </div>
//   );
// };

// export default BatchImageViewer;



/////////////////////user selectable prefetch count
// import React, { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { useAuth } from "../AuthContext";
// import config from "../Components/Config/config";

// import { ChevronLeft, ChevronRight } from "lucide-react";
// import ImageList from "./ImageList";
// import ImageDisplay from "./ImageView";

// const BatchImageViewer = () => {
//   const navigate = useNavigate();
//   const { batchName } = useParams();
//   const { getToken, isAuthenticated, logout, user } = useAuth();

//   // State management
//   const [imageList, setImageList] = useState([]);
//   const [filteredImages, setFilteredImages] = useState([]);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [imageUrl, setImageUrl] = useState(null);
//   const [isListLoading, setIsListLoading] = useState(false);
//   const [isImageLoading, setIsImageLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
//   const [isHighRes, setIsHighRes] = useState(false);
//   const [notification, setNotification] = useState({
//     show: false,
//     message: "",
//     type: "",
//   });

//   // Cache management
//   const [prefetchedImages, setPrefetchedImages] = useState(new Map());
//   const [prefetchQueue, setPrefetchQueue] = useState(new Set());
//   const MAX_CACHE_SIZE = 15; // Increased to accommodate more prefetch

//   const itemsPerPage = 10;
//   const loadingImageRef = React.useRef(null);

//   // Get prefetch count from localStorage
//   const getPrefetchCount = () => {
//     const savedCount = localStorage.getItem("prefetchCount");
//     if (savedCount) {
//       const countValue = parseInt(savedCount);
//       if (!isNaN(countValue) && countValue >= 1 && countValue <= 10) {
//         return countValue;
//       }
//     }
//     return 3; // Default value
//   };

//   // Get image scaling from localStorage
//   const getImageScaling = () => {
//     const savedScaling = localStorage.getItem("imageScaling");
//     if (savedScaling) {
//       const scalingValue = parseFloat(savedScaling);
//       if (!isNaN(scalingValue) && scalingValue >= 0.1 && scalingValue <= 1.0) {
//         return scalingValue;
//       }
//     }
//     return 0.3; // Default 30%
//   };

//   // Authentication check
//   useEffect(() => {
//     if (!isAuthenticated()) {
//       navigate("/login");
//       return;
//     }

//     if (batchName) {
//       fetchImageList();
//     } else {
//       navigate("/");
//     }
//   }, [navigate, batchName, isAuthenticated]);

//   // Filter images based on search
//   useEffect(() => {
//     const filtered = imageList.filter((image) =>
//       image.filename.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     const sortedFiltered = [...filtered].sort((a, b) =>
//       a.filename.localeCompare(b.filename)
//     );

//     setFilteredImages(sortedFiltered);
//     setCurrentPage(1);
//   }, [searchTerm, imageList]);

//   // Reset to low-res when image changes
//   useEffect(() => {
//     if (selectedImage) {
//       console.log("Selected image changed to:", selectedImage);
//       setIsHighRes(false);
//       loadImage(selectedImage, false);
//     }
//   }, [selectedImage]);

//   // Smart cache cleanup
//   useEffect(() => {
//     const prefetchCount = getPrefetchCount();
//     const CACHE_CLEANUP_THRESHOLD = Math.max(8, prefetchCount + 2);
    
//     if (prefetchedImages.size >= CACHE_CLEANUP_THRESHOLD) {
//       console.log(`Cache size: ${prefetchedImages.size}, running cleanup...`);
//       aggressiveCleanupCache();
//     }
//   }, [prefetchedImages.size]);

//   // Prefetch logic with dynamic count - sequential loading
//   useEffect(() => {
//     if (!selectedImage || filteredImages.length === 0 || isImageLoading) {
//       return;
//     }

//     const currentIndex = filteredImages.findIndex(
//       (img) => img.filename === selectedImage
//     );
//     if (currentIndex === -1) return;

//     const prefetchCount = getPrefetchCount();
//     const imagesToPrefetch = [];

//     // Prefetch the next N images based on user setting
//     for (let i = 1; i <= prefetchCount; i++) {
//       const nextIndex = currentIndex + i;
//       if (nextIndex < filteredImages.length) {
//         imagesToPrefetch.push(filteredImages[nextIndex].filename);
//       }
//     }

//     const prefetchTimeout = setTimeout(() => {
//       console.log(`Main image loaded, starting sequential prefetch of ${imagesToPrefetch.length} images...`);
//       cleanupPrefetchedImages(imagesToPrefetch);
      
//       // Sequential prefetch - each image loads one after another
//       const prefetchSequentially = async () => {
//         for (let i = 0; i < imagesToPrefetch.length; i++) {
//           const imageName = imagesToPrefetch[i];
//           const cacheKey = `${imageName}_lowres`;
          
//           // Check current cache state without causing re-render
//           let shouldPrefetch = true;
//           setPrefetchedImages((currentCache) => {
//             if (currentCache.has(cacheKey)) {
//               shouldPrefetch = false;
//               console.log(`Image ${imageName} already cached, skipping`);
//             }
//             return currentCache; // Return unchanged to avoid re-render
//           });
          
//           if (shouldPrefetch && !prefetchQueue.has(cacheKey)) {
//             console.log(`Sequentially prefetching image ${i + 1}/${imagesToPrefetch.length}: ${imageName}`);
//             await prefetchImage(imageName, false);
//             // Small delay between sequential loads to allow UI update
//             await new Promise(resolve => setTimeout(resolve, 150));
//           } else if (!shouldPrefetch) {
//             console.log(`Skipping ${imageName} - already cached`);
//           }
//         }
//         console.log("Sequential prefetch complete");
//       };
      
//       prefetchSequentially();
//     }, 1000);

//     return () => clearTimeout(prefetchTimeout);
//   }, [selectedImage, filteredImages, isImageLoading]);

//   // Cleanup on unmount
//   useEffect(() => {
//     return () => {
//       console.log("Component unmounting, cleaning up cache...");
//       prefetchedImages.forEach((imageUrl) => {
//         URL.revokeObjectURL(imageUrl);
//       });
//     };
//   }, []);

//   const showNotification = (message, type) => {
//     setNotification({ show: true, message, type });
//     setTimeout(() => {
//       setNotification({ show: false, message: "", type: "" });
//     }, 3000);
//   };

//   const aggressiveCleanupCache = () => {
//     const prefetchCount = getPrefetchCount();
    
//     setPrefetchedImages((prev) => {
//       const entries = Array.from(prev.entries());
//       const newMap = new Map();

//       const currentLowRes = `${selectedImage}_lowres`;
//       const currentHighRes = `${selectedImage}_highres`;
      
//       // Keep current image and next N images based on prefetch count
//       const currentIndex = filteredImages.findIndex(
//         (img) => img.filename === selectedImage
//       );
      
//       const keepKeys = new Set([currentLowRes, currentHighRes]);
      
//       for (let i = 1; i <= prefetchCount; i++) {
//         const nextIndex = currentIndex + i;
//         if (nextIndex < filteredImages.length) {
//           keepKeys.add(`${filteredImages[nextIndex].filename}_lowres`);
//         }
//       }

//       entries.forEach(([key, url]) => {
//         if (keepKeys.has(key)) {
//           newMap.set(key, url);
//         } else {
//           URL.revokeObjectURL(url);
//           console.log("Revoked cache:", key);
//         }
//       });

//       console.log(`Cache cleaned: ${prev.size} → ${newMap.size} entries`);
//       return newMap;
//     });
//   };

//   const cleanupPrefetchedImages = (currentTargets) => {
//     const dynamicMaxCache = Math.max(MAX_CACHE_SIZE, getPrefetchCount() + 5);
    
//     if (prefetchedImages.size <= dynamicMaxCache) {
//       return;
//     }

//     setPrefetchedImages((prev) => {
//       const newMap = new Map();
//       const entries = Array.from(prev.entries());

//       const keepKeys = new Set();
//       keepKeys.add(`${selectedImage}_lowres`);
//       keepKeys.add(`${selectedImage}_highres`);
      
//       currentTargets.forEach(name => {
//         keepKeys.add(`${name}_lowres`);
//       });

//       entries.forEach(([key, url]) => {
//         if (keepKeys.has(key)) {
//           newMap.set(key, url);
//         } else {
//           URL.revokeObjectURL(url);
//           console.log("Cleanup: revoked", key);
//         }
//       });

//       if (prev.size !== newMap.size) {
//         console.log(`Cache trimmed: ${prev.size} → ${newMap.size} entries`);
//       }

//       return newMap;
//     });
//   };

//   const handleLogout = () => {
//     logout();
//     navigate("/login");
//   };

//   const fetchImageList = async () => {
//     try {
//       setIsListLoading(true);
//       const token = getToken();

//       if (!token) {
//         navigate("/login");
//         return;
//       }

//       const url = `${config.API_BASE_URL}/api/batch_viewer/list_images/?batch_name=${encodeURIComponent(batchName)}`;

//       console.log("Fetching images from:", url);

//       const response = await fetch(url, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });

//       if (response.status === 401) {
//         showNotification("Session expired. Please login again.", "error");
//         logout();
//         navigate("/login");
//         return;
//       }

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error("Error fetching images:", errorText);
//         throw new Error(`Failed to fetch images: ${response.status}`);
//       }

//       const data = await response.json();
//       console.log("Images data:", data);

//       setImageList(data.images || []);

//       if (data.images && data.images.length > 0) {
//         setSelectedImage(data.images[0].filename);
//       }
//     } catch (error) {
//       console.error("Error fetching image list:", error);
//       showNotification("Failed to load images", "error");
//     } finally {
//       setIsListLoading(false);
//     }
//   };

//   const loadImage = async (imageName, highRes = false) => {
//     const loadKey = `${imageName}_${highRes ? 'highres' : 'lowres'}`;
    
//     if (loadingImageRef.current === loadKey) {
//       console.log("Already loading this image, skipping:", loadKey);
//       return;
//     }

//     try {
//       const cacheKey = `${imageName}_${highRes ? 'highres' : 'lowres'}`;
//       const prefetchedUrl = prefetchedImages.get(cacheKey);

//       if (prefetchedUrl) {
//         console.log(`Using cached image: ${imageName} (${highRes ? 'high-res' : 'low-res'})`);
//         setImageUrl(prefetchedUrl);
//         setIsImageLoading(false);
//         return;
//       }

//       console.log(`Loading image from server: ${imageName} (${highRes ? 'high-res' : 'low-res'})`);
      
//       loadingImageRef.current = loadKey;
//       setIsImageLoading(true);

//       const token = getToken();

//       if (!token) {
//         navigate("/login");
//         return;
//       }

//       const scaling = highRes ? 1.0 : getImageScaling();
//       const url = `${config.API_BASE_URL}/api/batch_viewer/get_image/?batch_name=${encodeURIComponent(batchName)}&image_name=${encodeURIComponent(imageName)}&scaling=${scaling}`;
//       console.log(`Fetching: ${url} (scaling: ${scaling})`);

//       const response = await fetch(url, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//         },
//       });

//       if (response.status === 401) {
//         showNotification("Session expired. Please login again.", "error");
//         logout();
//         navigate("/login");
//         return;
//       }

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error("Error response:", errorText);
//         throw new Error(`Failed to load image: ${response.status} - ${errorText}`);
//       }

//       const contentType = response.headers.get('content-type');
//       console.log("Response content-type:", contentType);

//       if (!contentType || !contentType.startsWith('image/')) {
//         throw new Error(`Invalid content type: ${contentType}`);
//       }

//       const imageBlob = await response.blob();
//       console.log(`Image blob received - size: ${imageBlob.size} bytes, type: ${imageBlob.type}`);
      
//       if (imageBlob.size === 0) {
//         throw new Error("Received empty image blob");
//       }

//       const oldUrl = imageUrl;
//       if (oldUrl && !Array.from(prefetchedImages.values()).includes(oldUrl)) {
//         URL.revokeObjectURL(oldUrl);
//       }
      
//       const newImageUrl = URL.createObjectURL(imageBlob);
//       console.log(`Created blob URL: ${newImageUrl.substring(0, 50)}...`);
      
//       setImageUrl(newImageUrl);

//       setPrefetchedImages((prev) => {
//         const newMap = new Map(prev);
//         newMap.set(cacheKey, newImageUrl);
        
//         const dynamicMaxCache = Math.max(MAX_CACHE_SIZE, getPrefetchCount() + 5);
//         if (newMap.size > dynamicMaxCache) {
//           console.log(`Cache overflow (${newMap.size}/${dynamicMaxCache}), cleanup needed`);
//         }
        
//         return newMap;
//       });
      
//       console.log(`Successfully loaded and cached: ${imageName} (${highRes ? 'high-res' : 'low-res'})`);
//     } catch (error) {
//       console.error("Error loading image:", error);
//       showNotification(`Failed to load image: ${error.message}`, "error");
//       setImageUrl(null);
//     } finally {
//       setIsImageLoading(false);
//       loadingImageRef.current = null;
//     }
//   };

//   const prefetchImage = async (imageName, highRes = false) => {
//     const cacheKey = `${imageName}_${highRes ? 'highres' : 'lowres'}`;
    
//     if (prefetchedImages.has(cacheKey) || prefetchQueue.has(cacheKey)) {
//       return;
//     }

//     const dynamicMaxCache = Math.max(MAX_CACHE_SIZE, getPrefetchCount() + 5);
//     if (prefetchedImages.size >= dynamicMaxCache - 1) {
//       console.log("Cache near limit, skipping prefetch");
//       return;
//     }

//     setPrefetchQueue((prev) => new Set([...prev, cacheKey]));

//     try {
//       const token = getToken();

//       if (!token) {
//         return;
//       }

//       const scaling = highRes ? 1.0 : getImageScaling();
//       const url = `${config.API_BASE_URL}/api/batch_viewer/get_image/?batch_name=${encodeURIComponent(batchName)}&image_name=${encodeURIComponent(imageName)}&scaling=${scaling}`;
//       console.log(`Prefetching: ${imageName} (${highRes ? 'high-res' : 'low-res'}) with scaling ${scaling}`);

//       const response = await fetch(url, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//         },
//       });

//       if (response.status === 401) {
//         console.log("Token expired during prefetch");
//         return;
//       }

//       if (response.ok) {
//         const contentType = response.headers.get('content-type');
//         if (!contentType || !contentType.startsWith('image/')) {
//           console.error("Invalid content type in prefetch:", contentType);
//           return;
//         }

//         const imageBlob = await response.blob();
        
//         if (imageBlob.size === 0) {
//           console.error("Received empty blob in prefetch");
//           return;
//         }

//         const imageUrl = URL.createObjectURL(imageBlob);

//         setPrefetchedImages((prev) => {
//           const newMap = new Map(prev);
//           newMap.set(cacheKey, imageUrl);
//           return newMap;
//         });

//         console.log(`Prefetched: ${imageName} (${highRes ? 'high-res' : 'low-res'})`);
//       }
//     } catch (error) {
//       console.error(`Error prefetching ${imageName}:`, error);
//     } finally {
//       setPrefetchQueue((prev) => {
//         const newSet = new Set(prev);
//         newSet.delete(cacheKey);
//         return newSet;
//       });
//     }
//   };

//   const handleImageSelect = (imageName) => {
//     if (isImageLoading) return;
//     setSelectedImage(imageName);
//   };

//   const handlePreviousImage = () => {
//     const currentIndex = filteredImages.findIndex(
//       (img) => img.filename === selectedImage
//     );
//     if (currentIndex > 0) {
//       const prevImage = filteredImages[currentIndex - 1];
//       setSelectedImage(prevImage.filename);

//       const prevPage = Math.ceil(currentIndex / itemsPerPage);
//       if (prevPage !== currentPage) {
//         setCurrentPage(prevPage);
//       }
//     }
//   };

//   const handleNextImage = () => {
//     const currentIndex = filteredImages.findIndex(
//       (img) => img.filename === selectedImage
//     );
//     if (currentIndex < filteredImages.length - 1) {
//       const nextImage = filteredImages[currentIndex + 1];
//       setSelectedImage(nextImage.filename);

//       const nextPage = Math.ceil((currentIndex + 2) / itemsPerPage);
//       if (nextPage !== currentPage) {
//         setCurrentPage(nextPage);
//       }
//     }
//   };

//   const handlePageChange = (newPage) => {
//     setCurrentPage(newPage);
//   };

//   const currentImageIndex = filteredImages.findIndex(
//     (img) => img.filename === selectedImage
//   );

//   return (
//     <div className="flex h-screen bg-gray-100 relative">
//       {notification.show && (
//         <div
//           className={`fixed top-4 right-4 p-4 rounded-lg shadow-lg z-50 transition-all duration-300 ${
//             notification.type === "success" ? "bg-green-500" : "bg-red-500"
//           } text-white`}
//         >
//           {notification.message}
//         </div>
//       )}

//       {/* Image List Sidebar */}
//       <ImageList
//         isSidebarCollapsed={isSidebarCollapsed}
//         batchName={batchName}
//         user={user}
//         navigate={navigate}
//         searchTerm={searchTerm}
//         setSearchTerm={setSearchTerm}
//         isListLoading={isListLoading}
//         filteredImages={filteredImages}
//         currentPage={currentPage}
//         itemsPerPage={itemsPerPage}
//         selectedImage={selectedImage}
//         handleImageSelect={handleImageSelect}
//         prefetchedImages={prefetchedImages}
//         handlePageChange={handlePageChange}
//       />

//       {/* Collapse/Expand Toggle Button */}
//       <button
//         onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
//         className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white border border-gray-300 rounded-r-lg p-2 hover:bg-gray-100 transition-all duration-300 shadow-md z-30"
//         style={{
//           left: isSidebarCollapsed ? "0" : "calc(25% - 1px)",
//           minWidth: "32px",
//         }}
//         title={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
//       >
//         {isSidebarCollapsed ? (
//           <ChevronRight className="w-5 h-5 text-gray-600" />
//         ) : (
//           <ChevronLeft className="w-5 h-5 text-gray-600" />
//         )}
//       </button>

//       {/* Image Display */}
//       <ImageDisplay
//         isSidebarCollapsed={isSidebarCollapsed}
//         selectedImage={selectedImage}
//         imageUrl={imageUrl}
//         setImageUrl={setImageUrl}
//         isImageLoading={isImageLoading}
//         isHighRes={isHighRes}
//         setIsHighRes={setIsHighRes}
//         filteredImages={filteredImages}
//         currentImageIndex={currentImageIndex}
//         loadImage={loadImage}
//         showNotification={showNotification}
//         isListLoading={isListLoading}
//         onNavigatePrevious={handlePreviousImage}
//         onNavigateNext={handleNextImage}
//       />
//     </div>
//   );
// };

// export default BatchImageViewer;


// import React, { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { useAuth } from "../AuthContext";
// import config from "../Components/Config/config";

// import { ChevronLeft, ChevronRight } from "lucide-react";
// import ImageList from "./ImageList";
// import ImageDisplay from "./ImageView";

// const BatchImageViewer = () => {
//   const navigate = useNavigate();
//   const { batchName } = useParams();
//   const { getToken, isAuthenticated, logout, user } = useAuth();

//   // State management
//   const [imageList, setImageList] = useState([]);
//   const [filteredImages, setFilteredImages] = useState([]);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [imageUrl, setImageUrl] = useState(null);
//   const [isListLoading, setIsListLoading] = useState(false);
//   const [isImageLoading, setIsImageLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
//   const [isHighRes, setIsHighRes] = useState(false);
//   const [isMultiSearchMode, setIsMultiSearchMode] = useState(false);
//   const [notification, setNotification] = useState({
//     show: false,
//     message: "",
//     type: "",
//   });

//   // Cache management
//   const [prefetchedImages, setPrefetchedImages] = useState(new Map());
//   const [prefetchQueue, setPrefetchQueue] = useState(new Set());
//   const prefetchedImagesRef = React.useRef(new Map());
//   const activeLoadingRef = React.useRef(new Set()); // Track active loads to prevent duplicates
//   const MAX_CACHE_SIZE = 15;

//   // Keep ref in sync with state
//   React.useEffect(() => {
//     prefetchedImagesRef.current = prefetchedImages;
//   }, [prefetchedImages]);

//   const itemsPerPage = 10;

//   // Get prefetch count from localStorage
//   const getPrefetchCount = () => {
//     const savedCount = localStorage.getItem("prefetchCount");
//     if (savedCount) {
//       const countValue = parseInt(savedCount);
//       if (!isNaN(countValue) && countValue >= 1 && countValue <= 10) {
//         return countValue;
//       }
//     }
//     return 3;
//   };

//   // Get image scaling from localStorage
//   const getImageScaling = () => {
//     const savedScaling = localStorage.getItem("imageScaling");
//     if (savedScaling) {
//       const scalingValue = parseFloat(savedScaling);
//       if (!isNaN(scalingValue) && scalingValue >= 0.1 && scalingValue <= 1.0) {
//         return scalingValue;
//       }
//     }
//     return 0.3;
//   };

//   // Parse multi-image search input
//   const parseMultiImageSearch = (searchText) => {
//     if (!searchText || !searchText.trim()) {
//       return [];
//     }

//     let imageNames = [];
    
//     if (searchText.includes('\n')) {
//       imageNames = searchText.split('\n');
//     } else if (searchText.includes(',')) {
//       imageNames = searchText.split(',');
//     } else if (searchText.includes(' ')) {
//       imageNames = searchText.split(' ');
//     } else {
//       imageNames = [searchText];
//     }

//     const cleanedNames = imageNames
//       .map(name => name.trim())
//       .filter(name => name.length > 0);

//     return cleanedNames;
//   };

//   // Handle multi-image search
//   const handleMultiImageSearch = () => {
//     const searchNames = parseMultiImageSearch(searchTerm);
    
//     if (searchNames.length === 0) {
//       showNotification("Please enter at least one image name", "error");
//       return;
//     }

//     const matchedImages = imageList.filter(image => 
//       searchNames.some(searchName => 
//         image.filename.toLowerCase().includes(searchName.toLowerCase())
//       )
//     );

//     if (matchedImages.length === 0) {
//       showNotification(`No images found matching the provided names`, "error");
//       return;
//     }

//     const sortedMatched = [...matchedImages].sort((a, b) =>
//       a.filename.localeCompare(b.filename)
//     );

//     setFilteredImages(sortedMatched);
//     setIsMultiSearchMode(true);
//     setCurrentPage(1);
    
//     if (sortedMatched.length > 0) {
//       setSelectedImage(sortedMatched[0].filename);
//     }

//     showNotification(`Found ${matchedImages.length} image(s)`, "success");
//   };

//   // Clear multi-image search
//   const clearMultiImageSearch = () => {
//     setSearchTerm("");
//     setIsMultiSearchMode(false);
//     setCurrentPage(1);
//   };

//   // Authentication check
//   useEffect(() => {
//     if (!isAuthenticated()) {
//       navigate("/login");
//       return;
//     }

//     if (batchName) {
//       fetchImageList();
//     } else {
//       navigate("/");
//     }
//   }, [navigate, batchName, isAuthenticated]);

//   // Filter images based on search
//   useEffect(() => {
//     if (isMultiSearchMode) {
//       return;
//     }

//     const filtered = imageList.filter((image) =>
//       image.filename.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     const sortedFiltered = [...filtered].sort((a, b) =>
//       a.filename.localeCompare(b.filename)
//     );

//     setFilteredImages(sortedFiltered);
//     setCurrentPage(1);
//   }, [searchTerm, imageList, isMultiSearchMode]);

//   const showNotification = (message, type) => {
//     setNotification({ show: true, message, type });
//     setTimeout(() => {
//       setNotification({ show: false, message: "", type: "" });
//     }, 3000);
//   };

//   // Smart cache cleanup
//   const aggressiveCleanupCache = React.useCallback(() => {
//     const prefetchCount = getPrefetchCount();
    
//     setPrefetchedImages((prev) => {
//       const entries = Array.from(prev.entries());
//       const newMap = new Map();

//       if (!selectedImage) {
//         return prev;
//       }

//       const currentLowRes = `${selectedImage}_lowres`;
//       const currentHighRes = `${selectedImage}_highres`;
      
//       const currentIndex = filteredImages.findIndex(
//         (img) => img.filename === selectedImage
//       );
      
//       const keepKeys = new Set([currentLowRes, currentHighRes]);
      
//       if (currentIndex !== -1) {
//         for (let i = 1; i <= prefetchCount; i++) {
//           const nextIndex = currentIndex + i;
//           if (nextIndex < filteredImages.length) {
//             keepKeys.add(`${filteredImages[nextIndex].filename}_lowres`);
//           }
//         }
//       }

//       let revokedCount = 0;
//       entries.forEach(([key, url]) => {
//         if (keepKeys.has(key)) {
//           newMap.set(key, url);
//         } else {
//           URL.revokeObjectURL(url);
//           revokedCount++;
//           console.log("Revoked cache:", key);
//         }
//       });

//       if (revokedCount > 0) {
//         console.log(`Cache cleaned: ${prev.size} → ${newMap.size} entries (revoked ${revokedCount})`);
//       }
//       return newMap;
//     });
//   }, [selectedImage, filteredImages]);

//   const cleanupPrefetchedImages = React.useCallback((currentTargets) => {
//     const dynamicMaxCache = Math.max(MAX_CACHE_SIZE, getPrefetchCount() + 5);
    
//     setTimeout(() => {
//       setPrefetchedImages((prev) => {
//         if (prev.size <= dynamicMaxCache) {
//           return prev;
//         }

//         const newMap = new Map();
//         const entries = Array.from(prev.entries());

//         const keepKeys = new Set();
//         if (selectedImage) {
//           keepKeys.add(`${selectedImage}_lowres`);
//           keepKeys.add(`${selectedImage}_highres`);
//         }
        
//         currentTargets.forEach(name => {
//           keepKeys.add(`${name}_lowres`);
//         });

//         let revokedCount = 0;
//         entries.forEach(([key, url]) => {
//           if (keepKeys.has(key)) {
//             newMap.set(key, url);
//           } else {
//             URL.revokeObjectURL(url);
//             revokedCount++;
//             console.log("Cleanup: revoked", key);
//           }
//         });

//         if (revokedCount > 0) {
//           console.log(`Cache trimmed: ${prev.size} → ${newMap.size} entries (revoked ${revokedCount})`);
//         }

//         return newMap;
//       });
//     }, 0);
//   }, [selectedImage]);

//   const loadImage = React.useCallback(async (imageName, highRes = false) => {
//     const cacheKey = `${imageName}_${highRes ? 'highres' : 'lowres'}`;
    
//     // CRITICAL: Check cache FIRST - instant display if available
//     const cachedUrl = prefetchedImagesRef.current.get(cacheKey);
//     if (cachedUrl) {
//       console.log(`✓ INSTANT display from cache: ${imageName} (${highRes ? 'high-res' : 'low-res'})`);
//       setImageUrl(cachedUrl);
//       setIsImageLoading(false);
//       return;
//     }
    
//     // Image not cached - show loading state immediately
//     console.log(`📥 Image not cached, showing loading state for: ${imageName}`);
//     setIsImageLoading(true);
    
//     // Check if this image is already being prefetched/loaded
//     if (activeLoadingRef.current.has(cacheKey)) {
//       console.log(`⏳ Image ${imageName} is already being loaded (prefetch or another request)`);
//       console.log(`   Will display automatically when it finishes loading...`);
//       // Don't start a duplicate request - the watcher effect will display it when ready
//       return;
//     }

//     try {
//       console.log(`📥 Loading from server: ${imageName} (${highRes ? 'high-res' : 'low-res'})`);
      
//       activeLoadingRef.current.add(cacheKey);

//       const token = getToken();

//       if (!token) {
//         navigate("/login");
//         return;
//       }

//       const scaling = highRes ? 1.0 : getImageScaling();
//       const url = `${config.API_BASE_URL}/api/batch_viewer/get_image/?batch_name=${encodeURIComponent(batchName)}&image_name=${encodeURIComponent(imageName)}&scaling=${scaling}`;

//       const response = await fetch(url, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//         },
//       });

//       if (response.status === 401) {
//         showNotification("Session expired. Please login again.", "error");
//         logout();
//         navigate("/login");
//         return;
//       }

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error("Error response:", errorText);
//         throw new Error(`Failed to load image: ${response.status}`);
//       }

//       const contentType = response.headers.get('content-type');

//       if (!contentType || !contentType.startsWith('image/')) {
//         throw new Error(`Invalid content type: ${contentType}`);
//       }

//       const imageBlob = await response.blob();
      
//       if (imageBlob.size === 0) {
//         throw new Error("Received empty image blob");
//       }

//       // Revoke old URL if not in cache
//       setImageUrl((oldUrl) => {
//         if (oldUrl && !Array.from(prefetchedImagesRef.current.values()).includes(oldUrl)) {
//           URL.revokeObjectURL(oldUrl);
//         }
//         return oldUrl;
//       });
      
//       const newImageUrl = URL.createObjectURL(imageBlob);
      
//       setImageUrl(newImageUrl);

//       // Add to cache
//       setPrefetchedImages((prev) => {
//         const newMap = new Map(prev);
//         newMap.set(cacheKey, newImageUrl);
        
//         const dynamicMaxCache = Math.max(MAX_CACHE_SIZE, getPrefetchCount() + 5);
//         if (newMap.size > dynamicMaxCache) {
//           console.log(`Cache overflow (${newMap.size}/${dynamicMaxCache})`);
//         }
        
//         return newMap;
//       });
      
//       console.log(`✓ Successfully loaded and cached: ${imageName} (${highRes ? 'high-res' : 'low-res'})`);
//     } catch (error) {
//       console.error("Error loading image:", error);
//       showNotification(`Failed to load image: ${error.message}`, "error");
//       setImageUrl(null);
//     } finally {
//       setIsImageLoading(false);
//       activeLoadingRef.current.delete(cacheKey);
//     }
//   }, [batchName, getToken, navigate, logout]);

//   // OPTIMIZED: Non-blocking, parallel prefetch with instant availability
//   const prefetchImage = React.useCallback(async (imageName, highRes = false) => {
//     const cacheKey = `${imageName}_${highRes ? 'highres' : 'lowres'}`;
    
//     // Quick check: already cached?
//     if (prefetchedImagesRef.current.has(cacheKey)) {
//       console.log(`✓ ${imageName} already cached, skip prefetch`);
//       return;
//     }

//     // Quick check: already loading?
//     if (activeLoadingRef.current.has(cacheKey)) {
//       console.log(`⏳ ${imageName} already loading, skip duplicate`);
//       return;
//     }

//     const dynamicMaxCache = Math.max(MAX_CACHE_SIZE, getPrefetchCount() + 5);
//     if (prefetchedImagesRef.current.size >= dynamicMaxCache - 1) {
//       console.log("Cache near limit, skip prefetch");
//       return;
//     }

//     // Mark as loading
//     activeLoadingRef.current.add(cacheKey);

//     try {
//       const token = getToken();
//       if (!token) return;

//       const scaling = highRes ? 1.0 : getImageScaling();
//       const url = `${config.API_BASE_URL}/api/batch_viewer/get_image/?batch_name=${encodeURIComponent(batchName)}&image_name=${encodeURIComponent(imageName)}&scaling=${scaling}`;
      
//       console.log(`🔄 Prefetch START (parallel): ${imageName}`);

//       const response = await fetch(url, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//         },
//       });

//       if (response.status === 401) {
//         console.log("Token expired during prefetch");
//         return;
//       }

//       if (response.ok) {
//         const contentType = response.headers.get('content-type');
//         if (!contentType || !contentType.startsWith('image/')) {
//           console.error("Invalid content type in prefetch:", contentType);
//           return;
//         }

//         const imageBlob = await response.blob();
        
//         if (imageBlob.size === 0) {
//           console.error("Received empty blob in prefetch");
//           return;
//         }

//         const imageUrl = URL.createObjectURL(imageBlob);

//         // CRITICAL: Immediately add to cache - makes it instantly available
//         setPrefetchedImages((prev) => {
//           const newMap = new Map(prev);
//           newMap.set(cacheKey, imageUrl);
//           return newMap;
//         });

//         console.log(`✅ Prefetch COMPLETE (now available): ${imageName}`);
//       }
//     } catch (error) {
//       console.error(`❌ Prefetch failed ${imageName}:`, error);
//     } finally {
//       // Remove from loading tracker
//       activeLoadingRef.current.delete(cacheKey);
//     }
//   }, [batchName, getToken]);

//   // Reset to low-res when image changes - load selected image FIRST
//   useEffect(() => {
//     if (selectedImage) {
//       console.log("🎯 Selected image changed to:", selectedImage);
//       setIsHighRes(false);
      
//       // Load the selected image IMMEDIATELY - this is priority #1
//       loadImage(selectedImage, false);
      
//       // Cleanup old cache after a delay
//       const cleanupTimer = setTimeout(() => {
//         const prefetchCount = getPrefetchCount();
//         const CACHE_SIZE_LIMIT = Math.max(MAX_CACHE_SIZE, prefetchCount + 5);
        
//         if (prefetchedImages.size > CACHE_SIZE_LIMIT) {
//           console.log("Triggering cleanup after image change");
//           aggressiveCleanupCache();
//         }
//       }, 2000);
      
//       return () => clearTimeout(cleanupTimer);
//     }
//   }, [selectedImage, loadImage, aggressiveCleanupCache, prefetchedImages.size]);

//   // WATCHER: Auto-switch to prefetched image when it becomes available
//   // This makes prefetched images instantly viewable without waiting for the queue
//   useEffect(() => {
//     if (!selectedImage || !isImageLoading) {
//       return; // Only relevant when we're waiting for an image to load
//     }

//     const cacheKey = `${selectedImage}_${isHighRes ? 'highres' : 'lowres'}`;
    
//     // Check if this image just became available in cache
//     if (prefetchedImages.has(cacheKey)) {
//       const cachedUrl = prefetchedImages.get(cacheKey);
//       console.log(`🎉 Prefetched image now available in cache! Displaying immediately: ${selectedImage}`);
//       setImageUrl(cachedUrl);
//       setIsImageLoading(false);
//     }
//   }, [prefetchedImages, selectedImage, isHighRes, isImageLoading]);

//   // Smart cache cleanup
//   useEffect(() => {
//     const prefetchCount = getPrefetchCount();
//     const CACHE_CLEANUP_THRESHOLD = Math.max(8, prefetchCount + 2);
    
//     if (prefetchedImages.size >= CACHE_CLEANUP_THRESHOLD) {
//       console.log(`Cache size: ${prefetchedImages.size}, running cleanup...`);
//       const timer = setTimeout(() => {
//         aggressiveCleanupCache();
//       }, 100);
//       return () => clearTimeout(timer);
//     }
//   }, [prefetchedImages.size, aggressiveCleanupCache]);

//   // CRITICAL: Start prefetch ONLY AFTER selected image is fully loaded
//   // Prefetch runs in background AFTER user sees their selected image
//   useEffect(() => {
//     // Don't start prefetch if:
//     // 1. No image is selected
//     // 2. Image is currently loading (wait for it to finish first!)
//     // 3. No filtered images available
//     if (!selectedImage || isImageLoading || filteredImages.length === 0) {
//       if (isImageLoading) {
//         console.log("⏳ Selected image still loading, prefetch will start after it finishes...");
//       }
//       return;
//     }

//     const currentIndex = filteredImages.findIndex(
//       (img) => img.filename === selectedImage
//     );
//     if (currentIndex === -1) return;

//     const prefetchCount = getPrefetchCount();
//     const imagesToPrefetch = [];

//     // Build list of images to prefetch
//     for (let i = 1; i <= prefetchCount; i++) {
//       const nextIndex = currentIndex + i;
//       if (nextIndex < filteredImages.length) {
//         imagesToPrefetch.push(filteredImages[nextIndex].filename);
//       }
//     }

//     if (imagesToPrefetch.length === 0) {
//       console.log("No images to prefetch (at end of list)");
//       return;
//     }

//     // Start prefetch with small delay AFTER selected image is displayed
//     const prefetchTimeout = setTimeout(() => {
//       console.log(`✅ Selected image loaded! Now starting background prefetch of ${imagesToPrefetch.length} images...`);
      
//       // Async cleanup (non-blocking)
//       cleanupPrefetchedImages(imagesToPrefetch);
      
//       // Launch ALL prefetch requests immediately in parallel
//       // Each one is independent and completes when ready
//       imagesToPrefetch.forEach((imageName, index) => {
//         const cacheKey = `${imageName}_lowres`;
        
//         // Quick check using ref (no re-render)
//         if (prefetchedImagesRef.current.has(cacheKey)) {
//           console.log(`✓ Image ${imageName} already cached`);
//           return;
//         }
        
//         // Start prefetch immediately - each request is independent
//         console.log(`🔄 Background prefetch #${index + 1}/${imagesToPrefetch.length}: ${imageName}`);
//         prefetchImage(imageName, false);
//         // No await! Each prefetch runs independently
//         // Images become available as soon as they finish loading
//       });
      
//       console.log(`✅ All ${imagesToPrefetch.length} background prefetch requests launched`);
//     }, 200); // Small delay to ensure selected image is displayed first

//     return () => clearTimeout(prefetchTimeout);
//   }, [selectedImage, isImageLoading, filteredImages, prefetchImage, cleanupPrefetchedImages]);

//   // Cleanup on unmount
//   useEffect(() => {
//     return () => {
//       console.log("Component unmounting, cleaning up cache...");
//       prefetchedImages.forEach((imageUrl) => {
//         URL.revokeObjectURL(imageUrl);
//       });
//       activeLoadingRef.current.clear();
//     };
//   }, []);

//   const handleLogout = () => {
//     logout();
//     navigate("/login");
//   };

//   const fetchImageList = async () => {
//     try {
//       setIsListLoading(true);
//       const token = getToken();

//       if (!token) {
//         navigate("/login");
//         return;
//       }

//       const url = `${config.API_BASE_URL}/api/batch_viewer/list_images/?batch_name=${encodeURIComponent(batchName)}`;

//       const response = await fetch(url, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });

//       if (response.status === 401) {
//         showNotification("Session expired. Please login again.", "error");
//         logout();
//         navigate("/login");
//         return;
//       }

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error("Error fetching images:", errorText);
//         throw new Error(`Failed to fetch images: ${response.status}`);
//       }

//       const data = await response.json();

//       setImageList(data.images || []);

//       if (data.images && data.images.length > 0) {
//         setSelectedImage(data.images[0].filename);
//       }
//     } catch (error) {
//       console.error("Error fetching image list:", error);
//       showNotification("Failed to load images", "error");
//     } finally {
//       setIsListLoading(false);
//     }
//   };

//   const handleImageSelect = (imageName) => {
//     // CRITICAL: Immediate selection - NO waiting, NO blocking
//     // If cached: displays instantly
//     // If not cached: loads on-demand while prefetch continues in background
//     console.log(`🎯 User selected: ${imageName} (will display immediately if cached)`);
//     setSelectedImage(imageName);
//   };

//   const handlePreviousImage = () => {
//     const currentIndex = filteredImages.findIndex(
//       (img) => img.filename === selectedImage
//     );
//     if (currentIndex > 0) {
//       const prevImage = filteredImages[currentIndex - 1];
//       setSelectedImage(prevImage.filename);

//       const prevPage = Math.ceil(currentIndex / itemsPerPage);
//       if (prevPage !== currentPage) {
//         setCurrentPage(prevPage);
//       }
//     }
//   };

//   const handleNextImage = () => {
//     const currentIndex = filteredImages.findIndex(
//       (img) => img.filename === selectedImage
//     );
//     if (currentIndex < filteredImages.length - 1) {
//       const nextImage = filteredImages[currentIndex + 1];
//       setSelectedImage(nextImage.filename);

//       const nextPage = Math.ceil((currentIndex + 2) / itemsPerPage);
//       if (nextPage !== currentPage) {
//         setCurrentPage(nextPage);
//       }
//     }
//   };

//   const handlePageChange = (newPage) => {
//     setCurrentPage(newPage);
//   };

//   const currentImageIndex = filteredImages.findIndex(
//     (img) => img.filename === selectedImage
//   );

//   return (
//     <div className="flex h-screen bg-gray-100 relative">
//       {notification.show && (
//         <div
//           className={`fixed top-4 right-4 p-4 rounded-lg shadow-lg z-50 transition-all duration-300 ${
//             notification.type === "success" ? "bg-green-500" : "bg-red-500"
//           } text-white`}
//         >
//           {notification.message}
//         </div>
//       )}

//       <ImageList
//         isSidebarCollapsed={isSidebarCollapsed}
//         batchName={batchName}
//         user={user}
//         navigate={navigate}
//         searchTerm={searchTerm}
//         setSearchTerm={setSearchTerm}
//         isListLoading={isListLoading}
//         filteredImages={filteredImages}
//         currentPage={currentPage}
//         itemsPerPage={itemsPerPage}
//         selectedImage={selectedImage}
//         handleImageSelect={handleImageSelect}
//         prefetchedImages={prefetchedImages}
//         handlePageChange={handlePageChange}
//         isMultiSearchMode={isMultiSearchMode}
//         onMultiImageSearch={handleMultiImageSearch}
//         onClearMultiSearch={clearMultiImageSearch}
//       />

//       <button
//         onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
//         className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white border border-gray-300 rounded-r-lg p-2 hover:bg-gray-100 transition-all duration-300 shadow-md z-30"
//         style={{
//           left: isSidebarCollapsed ? "0" : "calc(25% - 1px)",
//           minWidth: "32px",
//         }}
//         title={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
//       >
//         {isSidebarCollapsed ? (
//           <ChevronRight className="w-5 h-5 text-gray-600" />
//         ) : (
//           <ChevronLeft className="w-5 h-5 text-gray-600" />
//         )}
//       </button>

//       <ImageDisplay
//         isSidebarCollapsed={isSidebarCollapsed}
//         selectedImage={selectedImage}
//         imageUrl={imageUrl}
//         setImageUrl={setImageUrl}
//         isImageLoading={isImageLoading}
//         isHighRes={isHighRes}
//         setIsHighRes={setIsHighRes}
//         filteredImages={filteredImages}
//         currentImageIndex={currentImageIndex}
//         loadImage={loadImage}
//         showNotification={showNotification}
//         isListLoading={isListLoading}
//         onNavigatePrevious={handlePreviousImage}
//         onNavigateNext={handleNextImage}
//       />
//     </div>
//   );
// };

// export default BatchImageViewer;


// import React, { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { useAuth } from "../AuthContext";
// import config from "../Components/Config/config";

// import { ChevronLeft, ChevronRight } from "lucide-react";
// import ImageList from "./ImageList";
// import ImageDisplay from "./ImageView";

// const BatchImageViewer = () => {
//   const navigate = useNavigate();
//   const { ridName, batchName } = useParams();
//   const { getToken, isAuthenticated, logout, user } = useAuth();

//   // State management
//   const [imageList, setImageList] = useState([]);
//   const [filteredImages, setFilteredImages] = useState([]);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [imageUrl, setImageUrl] = useState(null);
//   const [isListLoading, setIsListLoading] = useState(false);
//   const [isImageLoading, setIsImageLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
//   const [isHighRes, setIsHighRes] = useState(false);
//   const [isMultiSearchMode, setIsMultiSearchMode] = useState(false);
//   const [notification, setNotification] = useState({
//     show: false,
//     message: "",
//     type: "",
//   });
  

//   // Cache management
//   const [prefetchedImages, setPrefetchedImages] = useState(new Map());
//   const [prefetchQueue, setPrefetchQueue] = useState(new Set());
//   const prefetchedImagesRef = React.useRef(new Map());
//   const activeLoadingRef = React.useRef(new Set()); // Track active loads to prevent duplicates
//   const MAX_CACHE_SIZE = 15;

//   // Keep ref in sync with state
//   React.useEffect(() => {
//     prefetchedImagesRef.current = prefetchedImages;
//   }, [prefetchedImages]);

//   const itemsPerPage = 10;

//   // Get prefetch count from localStorage
//   const getPrefetchCount = () => {
//     const savedCount = localStorage.getItem("prefetchCount");
//     if (savedCount) {
//       const countValue = parseInt(savedCount);
//       if (!isNaN(countValue) && countValue >= 1 && countValue <= 10) {
//         return countValue;
//       }
//     }
//     return 3;
//   };

//   // Get image scaling from localStorage
//   const getImageScaling = () => {
//     const savedScaling = localStorage.getItem("imageScaling");
//     if (savedScaling) {
//       const scalingValue = parseFloat(savedScaling);
//       if (!isNaN(scalingValue) && scalingValue >= 0.1 && scalingValue <= 1.0) {
//         return scalingValue;
//       }
//     }
//     return 0.3;
//   };

//   // Parse multi-image search input
//   const parseMultiImageSearch = (searchText) => {
//     if (!searchText || !searchText.trim()) {
//       return [];
//     }

//     let imageNames = [];
    
//     if (searchText.includes('\n')) {
//       imageNames = searchText.split('\n');
//     } else if (searchText.includes(',')) {
//       imageNames = searchText.split(',');
//     } else if (searchText.includes(' ')) {
//       imageNames = searchText.split(' ');
//     } else {
//       imageNames = [searchText];
//     }

//     const cleanedNames = imageNames
//       .map(name => name.trim())
//       .filter(name => name.length > 0);

//     return cleanedNames;
//   };

//   // Handle multi-image search
//   const handleMultiImageSearch = () => {
//     const searchNames = parseMultiImageSearch(searchTerm);
    
//     if (searchNames.length === 0) {
//       showNotification("Please enter at least one image name", "error");
//       return;
//     }

//     const matchedImages = imageList.filter(image => 
//       searchNames.some(searchName => 
//         image.filename.toLowerCase().includes(searchName.toLowerCase())
//       )
//     );

//     if (matchedImages.length === 0) {
//       showNotification(`No images found matching the provided names`, "error");
//       return;
//     }

//     const sortedMatched = [...matchedImages].sort((a, b) =>
//       a.filename.localeCompare(b.filename)
//     );

//     setFilteredImages(sortedMatched);
//     setIsMultiSearchMode(true);
//     setCurrentPage(1);
    
//     if (sortedMatched.length > 0) {
//       setSelectedImage(sortedMatched[0].filename);
//     }

//     showNotification(`Found ${matchedImages.length} image(s)`, "success");
//   };

//   // Clear multi-image search
//   const clearMultiImageSearch = () => {
//     setSearchTerm("");
//     setIsMultiSearchMode(false);
//     setCurrentPage(1);
//   };

//   // Authentication check
//   useEffect(() => {
//     if (!isAuthenticated()) {
//       navigate("/login");
//       return;
//     }

//     if (batchName) {
//       fetchImageList();
//     } else {
//       navigate("/");
//     }
//   }, [navigate, batchName, isAuthenticated]);

//   // Filter images based on search
//   useEffect(() => {
//     if (isMultiSearchMode) {
//       return;
//     }

//     const filtered = imageList.filter((image) =>
//       image.filename.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     const sortedFiltered = [...filtered].sort((a, b) =>
//       a.filename.localeCompare(b.filename)
//     );

//     setFilteredImages(sortedFiltered);
//     setCurrentPage(1);
//   }, [searchTerm, imageList, isMultiSearchMode]);

//   const showNotification = (message, type) => {
//     setNotification({ show: true, message, type });
//     setTimeout(() => {
//       setNotification({ show: false, message: "", type: "" });
//     }, 3000);
//   };

//   // Smart cache cleanup
//   const aggressiveCleanupCache = React.useCallback(() => {
//     const prefetchCount = getPrefetchCount();
    
//     setPrefetchedImages((prev) => {
//       const entries = Array.from(prev.entries());
//       const newMap = new Map();

//       if (!selectedImage) {
//         return prev;
//       }

//       const currentLowRes = `${selectedImage}_lowres`;
//       const currentHighRes = `${selectedImage}_highres`;
      
//       const currentIndex = filteredImages.findIndex(
//         (img) => img.filename === selectedImage
//       );
      
//       const keepKeys = new Set([currentLowRes, currentHighRes]);
      
//       if (currentIndex !== -1) {
//         for (let i = 1; i <= prefetchCount; i++) {
//           const nextIndex = currentIndex + i;
//           if (nextIndex < filteredImages.length) {
//             keepKeys.add(`${filteredImages[nextIndex].filename}_lowres`);
//           }
//         }
//       }

//       let revokedCount = 0;
//       entries.forEach(([key, url]) => {
//         if (keepKeys.has(key)) {
//           newMap.set(key, url);
//         } else {
//           URL.revokeObjectURL(url);
//           revokedCount++;
//           console.log("Revoked cache:", key);
//         }
//       });

//       if (revokedCount > 0) {
//         console.log(`Cache cleaned: ${prev.size} → ${newMap.size} entries (revoked ${revokedCount})`);
//       }
//       return newMap;
//     });
//   }, [selectedImage, filteredImages]);

//   const cleanupPrefetchedImages = React.useCallback((currentTargets) => {
//     const dynamicMaxCache = Math.max(MAX_CACHE_SIZE, getPrefetchCount() + 5);
    
//     setTimeout(() => {
//       setPrefetchedImages((prev) => {
//         if (prev.size <= dynamicMaxCache) {
//           return prev;
//         }

//         const newMap = new Map();
//         const entries = Array.from(prev.entries());

//         const keepKeys = new Set();
//         if (selectedImage) {
//           keepKeys.add(`${selectedImage}_lowres`);
//           keepKeys.add(`${selectedImage}_highres`);
//         }
        
//         currentTargets.forEach(name => {
//           keepKeys.add(`${name}_lowres`);
//         });

//         let revokedCount = 0;
//         entries.forEach(([key, url]) => {
//           if (keepKeys.has(key)) {
//             newMap.set(key, url);
//           } else {
//             URL.revokeObjectURL(url);
//             revokedCount++;
//             console.log("Cleanup: revoked", key);
//           }
//         });

//         if (revokedCount > 0) {
//           console.log(`Cache trimmed: ${prev.size} → ${newMap.size} entries (revoked ${revokedCount})`);
//         }

//         return newMap;
//       });
//     }, 0);
//   }, [selectedImage]);

//   const loadImage = React.useCallback(async (imageName, highRes = false) => {
//     const cacheKey = `${imageName}_${highRes ? 'highres' : 'lowres'}`;
    
//     // CRITICAL: Check cache FIRST - instant display if available
//     const cachedUrl = prefetchedImagesRef.current.get(cacheKey);
//     if (cachedUrl) {
//       console.log(`✓ INSTANT display from cache: ${imageName} (${highRes ? 'high-res' : 'low-res'})`);
//       setImageUrl(cachedUrl);
//       setIsImageLoading(false);
//       return;
//     }
    
//     // Image not cached - show loading state immediately
//     console.log(`📥 Image not cached, showing loading state for: ${imageName}`);
//     setIsImageLoading(true);
    
//     // Check if this image is already being prefetched/loaded
//     if (activeLoadingRef.current.has(cacheKey)) {
//       console.log(`⏳ Image ${imageName} is already being loaded (prefetch or another request)`);
//       console.log(`   Will display automatically when it finishes loading...`);
//       // Don't start a duplicate request - the watcher effect will display it when ready
//       return;
//     }

//     try {
//       console.log(`📥 Loading from server: ${imageName} (${highRes ? 'high-res' : 'low-res'})`);
      
//       activeLoadingRef.current.add(cacheKey);

//       const token = getToken();

//       if (!token) {
//         navigate("/login");
//         return;
//       }

//       const scaling = highRes ? 1.0 : getImageScaling();
//       const url = `${config.API_BASE_URL}/api/batch_viewer/get_image/?batch_name=${encodeURIComponent(batchName)}&image_name=${encodeURIComponent(imageName)}&rid_name=${encodeURIComponent(ridName)}&scaling=${scaling}`;

//       const response = await fetch(url, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//         },
//       });

//       if (response.status === 401) {
//         showNotification("Session expired. Please login again.", "error");
//         logout();
//         navigate("/login");
//         return;
//       }

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error("Error response:", errorText);
//         throw new Error(`Failed to load image: ${response.status}`);
//       }

//       const contentType = response.headers.get('content-type');

//       if (!contentType || !contentType.startsWith('image/')) {
//         throw new Error(`Invalid content type: ${contentType}`);
//       }

//       const imageBlob = await response.blob();
      
//       if (imageBlob.size === 0) {
//         throw new Error("Received empty image blob");
//       }

//       // Revoke old URL if not in cache
//       setImageUrl((oldUrl) => {
//         if (oldUrl && !Array.from(prefetchedImagesRef.current.values()).includes(oldUrl)) {
//           URL.revokeObjectURL(oldUrl);
//         }
//         return oldUrl;
//       });
      
//       const newImageUrl = URL.createObjectURL(imageBlob);
      
//       setImageUrl(newImageUrl);

//       // Add to cache
//       setPrefetchedImages((prev) => {
//         const newMap = new Map(prev);
//         newMap.set(cacheKey, newImageUrl);
        
//         const dynamicMaxCache = Math.max(MAX_CACHE_SIZE, getPrefetchCount() + 5);
//         if (newMap.size > dynamicMaxCache) {
//           console.log(`Cache overflow (${newMap.size}/${dynamicMaxCache})`);
//         }
        
//         return newMap;
//       });
      
//       console.log(`✓ Successfully loaded and cached: ${imageName} (${highRes ? 'high-res' : 'low-res'})`);
//     } catch (error) {
//       console.error("Error loading image:", error);
//       showNotification(`Failed to load image: ${error.message}`, "error");
//       setImageUrl(null);
//     } finally {
//       setIsImageLoading(false);
//       activeLoadingRef.current.delete(cacheKey);
//     }
//   },  [batchName, ridName, getToken, navigate, logout]);

//   // OPTIMIZED: Non-blocking, parallel prefetch with instant availability
//   const prefetchImage = React.useCallback(async (imageName, highRes = false) => {
//     const cacheKey = `${imageName}_${highRes ? 'highres' : 'lowres'}`;
    
//     // Quick check: already cached?
//     if (prefetchedImagesRef.current.has(cacheKey)) {
//       console.log(`✓ ${imageName} already cached, skip prefetch`);
//       return;
//     }

//     // Quick check: already loading?
//     if (activeLoadingRef.current.has(cacheKey)) {
//       console.log(`⏳ ${imageName} already loading, skip duplicate`);
//       return;
//     }

//     const dynamicMaxCache = Math.max(MAX_CACHE_SIZE, getPrefetchCount() + 5);
//     if (prefetchedImagesRef.current.size >= dynamicMaxCache - 1) {
//       console.log("Cache near limit, skip prefetch");
//       return;
//     }

//     // Mark as loading
//     activeLoadingRef.current.add(cacheKey);

//     try {
//       const token = getToken();
//       if (!token) return;

//       const scaling = highRes ? 1.0 : getImageScaling();
//       const url = `${config.API_BASE_URL}/api/batch_viewer/get_image/?batch_name=${encodeURIComponent(batchName)}&image_name=${encodeURIComponent(imageName)}&rid_name=${encodeURIComponent(ridName)}&scaling=${scaling}`;

//       console.log(`🔄 Prefetch START (parallel): ${imageName}`);

//       const response = await fetch(url, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//         },
//       });

//       if (response.status === 401) {
//         console.log("Token expired during prefetch");
//         return;
//       }

//       if (response.ok) {
//         const contentType = response.headers.get('content-type');
//         if (!contentType || !contentType.startsWith('image/')) {
//           console.error("Invalid content type in prefetch:", contentType);
//           return;
//         }

//         const imageBlob = await response.blob();
        
//         if (imageBlob.size === 0) {
//           console.error("Received empty blob in prefetch");
//           return;
//         }

//         const imageUrl = URL.createObjectURL(imageBlob);

//         // CRITICAL: Immediately add to cache - makes it instantly available
//         setPrefetchedImages((prev) => {
//           const newMap = new Map(prev);
//           newMap.set(cacheKey, imageUrl);
//           return newMap;
//         });

//         console.log(`✅ Prefetch COMPLETE (now available): ${imageName}`);
//       }
//     } catch (error) {
//       console.error(`❌ Prefetch failed ${imageName}:`, error);
//     } finally {
//       // Remove from loading tracker
//       activeLoadingRef.current.delete(cacheKey);
//     }
//   }, [batchName, ridName, getToken]);

//   // Reset to low-res when image changes - load selected image FIRST
//   useEffect(() => {
//     if (selectedImage) {
//       console.log("🎯 Selected image changed to:", selectedImage);
//       setIsHighRes(false);
      
//       // Load the selected image IMMEDIATELY - this is priority #1
//       loadImage(selectedImage, false);
      
//       // Cleanup old cache after a delay
//       const cleanupTimer = setTimeout(() => {
//         const prefetchCount = getPrefetchCount();
//         const CACHE_SIZE_LIMIT = Math.max(MAX_CACHE_SIZE, prefetchCount + 5);
        
//         if (prefetchedImages.size > CACHE_SIZE_LIMIT) {
//           console.log("Triggering cleanup after image change");
//           aggressiveCleanupCache();
//         }
//       }, 2000);
      
//       return () => clearTimeout(cleanupTimer);
//     }
//   }, [selectedImage, loadImage, aggressiveCleanupCache, prefetchedImages.size]);

//   // WATCHER: Auto-switch to prefetched image when it becomes available
//   // This makes prefetched images instantly viewable without waiting for the queue
//   useEffect(() => {
//     if (!selectedImage || !isImageLoading) {
//       return; // Only relevant when we're waiting for an image to load
//     }

//     const cacheKey = `${selectedImage}_${isHighRes ? 'highres' : 'lowres'}`;
    
//     // Check if this image just became available in cache
//     if (prefetchedImages.has(cacheKey)) {
//       const cachedUrl = prefetchedImages.get(cacheKey);
//       console.log(`🎉 Prefetched image now available in cache! Displaying immediately: ${selectedImage}`);
//       setImageUrl(cachedUrl);
//       setIsImageLoading(false);
//     }
//   }, [prefetchedImages, selectedImage, isHighRes, isImageLoading]);

//   // Smart cache cleanup
//   useEffect(() => {
//     const prefetchCount = getPrefetchCount();
//     const CACHE_CLEANUP_THRESHOLD = Math.max(8, prefetchCount + 2);
    
//     if (prefetchedImages.size >= CACHE_CLEANUP_THRESHOLD) {
//       console.log(`Cache size: ${prefetchedImages.size}, running cleanup...`);
//       const timer = setTimeout(() => {
//         aggressiveCleanupCache();
//       }, 100);
//       return () => clearTimeout(timer);
//     }
//   }, [prefetchedImages.size, aggressiveCleanupCache]);

//   // CRITICAL: Start prefetch ONLY AFTER selected image is fully loaded
//   // Prefetch runs in background AFTER user sees their selected image
//   useEffect(() => {
//     // Don't start prefetch if:
//     // 1. No image is selected
//     // 2. Image is currently loading (wait for it to finish first!)
//     // 3. No filtered images available
//     if (!selectedImage || isImageLoading || filteredImages.length === 0) {
//       if (isImageLoading) {
//         console.log("⏳ Selected image still loading, prefetch will start after it finishes...");
//       }
//       return;
//     }

//     const currentIndex = filteredImages.findIndex(
//       (img) => img.filename === selectedImage
//     );
//     if (currentIndex === -1) return;

//     const prefetchCount = getPrefetchCount();
//     const imagesToPrefetch = [];

//     // Build list of images to prefetch
//     for (let i = 1; i <= prefetchCount; i++) {
//       const nextIndex = currentIndex + i;
//       if (nextIndex < filteredImages.length) {
//         imagesToPrefetch.push(filteredImages[nextIndex].filename);
//       }
//     }

//     if (imagesToPrefetch.length === 0) {
//       console.log("No images to prefetch (at end of list)");
//       return;
//     }

//     // Start prefetch with small delay AFTER selected image is displayed
//     const prefetchTimeout = setTimeout(() => {
//       console.log(`✅ Selected image loaded! Now starting background prefetch of ${imagesToPrefetch.length} images...`);
      
//       // Async cleanup (non-blocking)
//       cleanupPrefetchedImages(imagesToPrefetch);
      
//       // Launch ALL prefetch requests immediately in parallel
//       // Each one is independent and completes when ready
//       imagesToPrefetch.forEach((imageName, index) => {
//         const cacheKey = `${imageName}_lowres`;
        
//         // Quick check using ref (no re-render)
//         if (prefetchedImagesRef.current.has(cacheKey)) {
//           console.log(`✓ Image ${imageName} already cached`);
//           return;
//         }
        
//         // Start prefetch immediately - each request is independent
//         console.log(`🔄 Background prefetch #${index + 1}/${imagesToPrefetch.length}: ${imageName}`);
//         prefetchImage(imageName, false);
//         // No await! Each prefetch runs independently
//         // Images become available as soon as they finish loading
//       });
      
//       console.log(`✅ All ${imagesToPrefetch.length} background prefetch requests launched`);
//     }, 200); // Small delay to ensure selected image is displayed first

//     return () => clearTimeout(prefetchTimeout);
//   }, [selectedImage, isImageLoading, filteredImages, prefetchImage, cleanupPrefetchedImages]);

//   // Cleanup on unmount
//   useEffect(() => {
//     return () => {
//       console.log("Component unmounting, cleaning up cache...");
//       prefetchedImages.forEach((imageUrl) => {
//         URL.revokeObjectURL(imageUrl);
//       });
//       activeLoadingRef.current.clear();
//     };
//   }, []);

//   const handleLogout = () => {
//     logout();
//     navigate("/login");
//   };

// const fetchImageList = async () => {
//   try {
//     setIsListLoading(true);
//     const token = getToken();

//     if (!token) {
//       navigate("/login");
//       return;
//     }

//     const url = `${config.API_BASE_URL}/api/batch_viewer/list_images/?batch_name=${encodeURIComponent(batchName)}&rid_name=${encodeURIComponent(ridName)}`;

//     const response = await fetch(url, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'application/json',
//       },
//     });

//     if (response.status === 401) {
//       showNotification("Session expired. Please login again.", "error");
//       logout();
//       navigate("/login");
//       return;
//     }

//     if (!response.ok) {
//       const errorText = await response.text();
//       console.error("Error fetching images:", errorText);
//       throw new Error(`Failed to fetch images: ${response.status}`);
//     }

//     const data = await response.json();

//     setImageList(data.images || []);

//     if (data.images && data.images.length > 0) {
//       setSelectedImage(data.images[0].filename);
//     }
//   } catch (error) {
//     console.error("Error fetching image list:", error);
//     showNotification("Failed to load images", "error");
//   } finally {
//     setIsListLoading(false);
//   }
// };

//   const handleImageSelect = (imageName) => {
//     // CRITICAL: Immediate selection - NO waiting, NO blocking
//     // If cached: displays instantly
//     // If not cached: loads on-demand while prefetch continues in background
//     console.log(`🎯 User selected: ${imageName} (will display immediately if cached)`);
//     setSelectedImage(imageName);
//   };

//   const handlePreviousImage = () => {
//     const currentIndex = filteredImages.findIndex(
//       (img) => img.filename === selectedImage
//     );
//     if (currentIndex > 0) {
//       const prevImage = filteredImages[currentIndex - 1];
//       setSelectedImage(prevImage.filename);

//       const prevPage = Math.ceil(currentIndex / itemsPerPage);
//       if (prevPage !== currentPage) {
//         setCurrentPage(prevPage);
//       }
//     }
//   };

//   const handleNextImage = () => {
//     const currentIndex = filteredImages.findIndex(
//       (img) => img.filename === selectedImage
//     );
//     if (currentIndex < filteredImages.length - 1) {
//       const nextImage = filteredImages[currentIndex + 1];
//       setSelectedImage(nextImage.filename);

//       const nextPage = Math.ceil((currentIndex + 2) / itemsPerPage);
//       if (nextPage !== currentPage) {
//         setCurrentPage(nextPage);
//       }
//     }
//   };

//   const handlePageChange = (newPage) => {
//     setCurrentPage(newPage);
//   };

//   const currentImageIndex = filteredImages.findIndex(
//     (img) => img.filename === selectedImage
//   );

//   return (
//     <div className="flex h-screen bg-gray-100 relative">
//       {notification.show && (
//         <div
//           className={`fixed top-4 right-4 p-4 rounded-lg shadow-lg z-50 transition-all duration-300 ${
//             notification.type === "success" ? "bg-green-500" : "bg-red-500"
//           } text-white`}
//         >
//           {notification.message}
//         </div>
//       )}

//       <ImageList
//         isSidebarCollapsed={isSidebarCollapsed}
//         batchName={batchName}
//         user={user}
//         ridName={ridName} 
//         navigate={navigate}
//         searchTerm={searchTerm}
//         setSearchTerm={setSearchTerm}
//         isListLoading={isListLoading}
//         filteredImages={filteredImages}
//         currentPage={currentPage}
//         itemsPerPage={itemsPerPage}
//         selectedImage={selectedImage}
//         handleImageSelect={handleImageSelect}
//         prefetchedImages={prefetchedImages}
//         handlePageChange={handlePageChange}
//         isMultiSearchMode={isMultiSearchMode}
//         onMultiImageSearch={handleMultiImageSearch}
//         onClearMultiSearch={clearMultiImageSearch}
//       />

//       <button
//         onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
//         className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white border border-gray-300 rounded-r-lg p-2 hover:bg-gray-100 transition-all duration-300 shadow-md z-30"
//         style={{
//           left: isSidebarCollapsed ? "0" : "calc(25% - 1px)",
//           minWidth: "32px",
//         }}
//         title={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
//       >
//         {isSidebarCollapsed ? (
//           <ChevronRight className="w-5 h-5 text-gray-600" />
//         ) : (
//           <ChevronLeft className="w-5 h-5 text-gray-600" />
//         )}
//       </button>

//       <ImageDisplay
//         isSidebarCollapsed={isSidebarCollapsed}
//         selectedImage={selectedImage}
//         imageUrl={imageUrl}
//         setImageUrl={setImageUrl}
//         isImageLoading={isImageLoading}
//         isHighRes={isHighRes}
//         setIsHighRes={setIsHighRes}
//         filteredImages={filteredImages}
//         currentImageIndex={currentImageIndex}
//         loadImage={loadImage}
//         showNotification={showNotification}
//         isListLoading={isListLoading}
//         onNavigatePrevious={handlePreviousImage}
//         onNavigateNext={handleNextImage}
//       />
//     </div>
//   );
// };
// export default BatchImageViewer;


import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../AuthContext";
import config from "../Components/Config/config";
import { ChevronLeft, ChevronRight } from "lucide-react";
import ImageList from "./ImageList";
import ImageDisplay from "./ImageView";

const MAX_CACHE = 20;

function createCache() {
  const map = new Map();
  return {
    has:  (k) => map.has(k),
    get:  (k) => map.get(k),
    set:  (k, url) => {
      if (map.size >= MAX_CACHE) {
        const oldest = map.keys().next().value;
        URL.revokeObjectURL(map.get(oldest));
        map.delete(oldest);
      }
      map.set(k, url);
    },
    evictExcept: (keepSet) => {
      for (const [k, url] of map.entries()) {
        if (!keepSet.has(k)) {
          URL.revokeObjectURL(url);
          map.delete(k);
        }
      }
    },
    clear: () => {
      for (const url of map.values()) URL.revokeObjectURL(url);
      map.clear();
    },
    keys: () => map.keys(),
    size: () => map.size,
  };
}

const getPrefetchCount = () => {
  const v = parseInt(localStorage.getItem("prefetchCount") ?? "3");
  return isNaN(v) || v < 1 || v > 10 ? 3 : v;
};

const getImageScaling = () => {
  const v = parseFloat(localStorage.getItem("imageScaling") ?? "0.3");
  return isNaN(v) || v < 0.1 || v > 1.0 ? 0.3 : v;
};

const BatchImageViewer = () => {
  const navigate = useNavigate();
  const { ridName, batchName } = useParams();
  const { getToken, isAuthenticated, logout, user } = useAuth();

  const [imageList, setImageList]                   = useState([]);
  const [filteredImages, setFilteredImages]         = useState([]);
  const [selectedImage, setSelectedImage]           = useState(null);
  const [imageUrl, setImageUrl]                     = useState(null);
  const [isListLoading, setIsListLoading]           = useState(false);
  const [isImageLoading, setIsImageLoading]         = useState(false);
  const [searchTerm, setSearchTerm]                 = useState("");
  const [currentPage, setCurrentPage]               = useState(1);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isHighRes, setIsHighRes]                   = useState(false);
  const [isMultiSearchMode, setIsMultiSearchMode]   = useState(false);
  const [notification, setNotification]             = useState({ show: false, message: "", type: "" });
  const [cachedSet, setCachedSet]                   = useState(new Set());

  const cache            = useRef(createCache());
  const selectedImageRef = useRef(null);
  const pendingCacheKey  = useRef(null);

  // Separate abort maps for load vs prefetch so we can cancel ONLY
  // prefetches without touching the selected image's load request
  const loadAbortMap     = useRef(new Map()); // cacheKey → AbortController (loadImage only)
  const prefetchAbortMap = useRef(new Map()); // cacheKey → AbortController (prefetchImage only)
  const loadingSet       = useRef(new Set()); // tracks all in-flight keys (both)

  const itemsPerPage = 10;

  useEffect(() => {
    selectedImageRef.current = selectedImage;
  }, [selectedImage]);

  const showNotification = useCallback((message, type) => {
    setNotification({ show: true, message, type });
    setTimeout(() => setNotification({ show: false, message: "", type: "" }), 3000);
  }, []);

  // Cancel ALL in-flight prefetches immediately.
  // Called the moment user selects a new image so bandwidth is freed
  // entirely for the selected image fetch.
  const cancelAllPrefetches = useCallback(() => {
    for (const ctrl of prefetchAbortMap.current.values()) {
      ctrl.abort();
    }
    // Don't clear the map here — each fetch's finally block does that
  }, []);

  // ─────────────────────────────────────────────
  // Auth + initial load
  // ─────────────────────────────────────────────
  useEffect(() => {
    if (!isAuthenticated()) { navigate("/login"); return; }
    if (batchName) fetchImageList();
    else navigate("/");
  }, [batchName]); // eslint-disable-line

  // ─────────────────────────────────────────────
  // Search filter
  // ─────────────────────────────────────────────
  useEffect(() => {
    if (isMultiSearchMode) return;
    const lower = searchTerm.toLowerCase();
    const filtered = [...imageList]
      .filter((img) => img.filename.toLowerCase().includes(lower))
      .sort((a, b) => a.filename.localeCompare(b.filename));
    setFilteredImages(filtered);
    setCurrentPage(1);
  }, [searchTerm, imageList, isMultiSearchMode]);

  // ─────────────────────────────────────────────
  // Cleanup on unmount
  // ─────────────────────────────────────────────
  useEffect(() => {
    return () => {
      for (const ctrl of loadAbortMap.current.values()) ctrl.abort();
      for (const ctrl of prefetchAbortMap.current.values()) ctrl.abort();
      cache.current.clear();
      loadingSet.current.clear();
      loadAbortMap.current.clear();
      prefetchAbortMap.current.clear();
    };
  }, []);

  // ─────────────────────────────────────────────
  // Core image loader — HIGHEST PRIORITY
  //
  // Always called for the selected image.
  // Uses loadAbortMap — completely separate from prefetches.
  // ─────────────────────────────────────────────
  const loadImage = useCallback(async (imageName, highRes = false) => {
    const cacheKey = `${imageName}_${highRes ? "hi" : "lo"}`;

    // Cache hit — instant display
    if (cache.current.has(cacheKey)) {
      pendingCacheKey.current = null;
      setImageUrl(cache.current.get(cacheKey));
      setIsImageLoading(false);
      return;
    }

    // Cache miss — show spinner, record what we're waiting for
    pendingCacheKey.current = cacheKey;
    setImageUrl(null);
    setIsImageLoading(true);

    // If loadImage is already fetching this exact key (e.g. res toggle),
    // don't start a duplicate — the existing fetch will resolve it
    if (loadAbortMap.current.has(cacheKey)) return;

    // If a prefetch had this in-flight, abort it — we'll fetch it ourselves
    // at higher priority (dedicated connection, not queued behind others)
    if (prefetchAbortMap.current.has(cacheKey)) {
      prefetchAbortMap.current.get(cacheKey).abort();
    }

    // Remove from loadingSet so our new fetch can proceed
    loadingSet.current.delete(cacheKey);

    loadingSet.current.add(cacheKey);
    const controller = new AbortController();
    loadAbortMap.current.set(cacheKey, controller);

    try {
      const token = getToken();
      if (!token) { navigate("/login"); return; }

      const scaling = highRes ? 1.0 : getImageScaling();
      const url =
        `${config.API_BASE_URL}/api/batch_viewer/get_image/` +
        `?batch_name=${encodeURIComponent(batchName)}` +
        `&image_name=${encodeURIComponent(imageName)}` +
        `&rid_name=${encodeURIComponent(ridName)}` +
        `&scaling=${scaling}`;

      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
        signal: controller.signal,
      });

      if (response.status === 401) { logout(); navigate("/login"); return; }
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const blob = await response.blob();
      if (!blob.size) throw new Error("Empty image response");

      const objectUrl = URL.createObjectURL(blob);
      cache.current.set(cacheKey, objectUrl);

      if (
        selectedImageRef.current === imageName &&
        pendingCacheKey.current === cacheKey
      ) {
        pendingCacheKey.current = null;
        setImageUrl(objectUrl);
        setIsImageLoading(false);
      }

    } catch (err) {
      if (err.name === "AbortError") return;
      console.error("loadImage failed:", err);
      if (
        selectedImageRef.current === imageName &&
        pendingCacheKey.current === cacheKey
      ) {
        pendingCacheKey.current = null;
        showNotification(`Failed to load image: ${err.message}`, "error");
        setImageUrl(null);
        setIsImageLoading(false);
      }
    } finally {
      loadingSet.current.delete(cacheKey);
      loadAbortMap.current.delete(cacheKey);
    }
  }, [batchName, ridName, getToken, navigate, logout, showNotification]);

  // ─────────────────────────────────────────────
  // Background prefetch — LOW PRIORITY
  //
  // Only starts after selected image is displayed (isImageLoading=false).
  // Uses prefetchAbortMap — cancelled immediately when user selects
  // a new image, freeing all bandwidth for the new selected image load.
  // Images are fetched ONE AT A TIME in order (next, then next+1, etc.)
  // so image N+1 is always ready before N+2.
  // ─────────────────────────────────────────────
  const prefetchImage = useCallback(async (imageName) => {
    const cacheKey = `${imageName}_lo`;

    if (cache.current.has(cacheKey)) return;
    if (loadingSet.current.has(cacheKey)) return;
    if (cache.current.size() >= MAX_CACHE - 1) return;

    loadingSet.current.add(cacheKey);
    const controller = new AbortController();
    prefetchAbortMap.current.set(cacheKey, controller);

    try {
      const token = getToken();
      if (!token) return;

      const url =
        `${config.API_BASE_URL}/api/batch_viewer/get_image/` +
        `?batch_name=${encodeURIComponent(batchName)}` +
        `&image_name=${encodeURIComponent(imageName)}` +
        `&rid_name=${encodeURIComponent(ridName)}` +
        `&scaling=${getImageScaling()}`;

      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
        signal: controller.signal,
      });

      if (!response.ok) return;
      const blob = await response.blob();
      if (!blob.size) return;

      const objectUrl = URL.createObjectURL(blob);
      cache.current.set(cacheKey, objectUrl);

      // Update "✓ Ready" badge in sidebar
      setCachedSet((prev) => {
        const next = new Set(prev);
        next.add(`${imageName}_lowres`);
        return next;
      });

    } catch (err) {
      if (err.name !== "AbortError") {
        console.warn("Prefetch failed:", imageName, err.message);
      }
    } finally {
      loadingSet.current.delete(cacheKey);
      prefetchAbortMap.current.delete(cacheKey);
    }
  }, [batchName, ridName, getToken]);

  // ─────────────────────────────────────────────
  // React to selected image change
  //
  // Priority order:
  //   1. Cancel ALL prefetches immediately (free all bandwidth)
  //   2. Show spinner right away if not cached
  //   3. Fetch selected image at full priority
  // ─────────────────────────────────────────────
  useEffect(() => {
    if (!selectedImage) return;

    // Step 1: Kill every prefetch immediately — selected image gets
    // all available bandwidth on its own dedicated fetch
    cancelAllPrefetches();

    setIsHighRes(false);

    const cacheKey = `${selectedImage}_lo`;
    if (!cache.current.has(cacheKey)) {
      pendingCacheKey.current = cacheKey;
      setImageUrl(null);
      setIsImageLoading(true);
    }

    // Step 2: Fetch selected image (or return from cache instantly)
    loadImage(selectedImage, false);
  }, [selectedImage]); // eslint-disable-line

  // ─────────────────────────────────────────────
  // After selected image is displayed,
  // prefetch next images ONE BY ONE in order.
  //
  // Sequential (not parallel) so image N+1 is always
  // available before N+2, N+3, etc.
  // ─────────────────────────────────────────────
  useEffect(() => {
    if (!selectedImage || isImageLoading || filteredImages.length === 0) return;

    const currentIndex = filteredImages.findIndex((img) => img.filename === selectedImage);
    if (currentIndex === -1) return;

    const prefetchCount = getPrefetchCount();
    const toFetch = [];
    for (let i = 1; i <= prefetchCount; i++) {
      const next = filteredImages[currentIndex + i];
      if (next) toFetch.push(next.filename);
    }

    // Evict cache entries outside the window
    const keepKeys = new Set([
      `${selectedImage}_lo`,
      `${selectedImage}_hi`,
      ...toFetch.map((n) => `${n}_lo`),
    ]);
    cache.current.evictExcept(keepKeys);

    // Sync "✓ Ready" badges after eviction
    setCachedSet(() => {
      const next = new Set();
      for (const k of cache.current.keys()) {
        if (k.endsWith("_lo")) {
          next.add(`${k.replace(/_lo$/, "")}_lowres`);
        }
      }
      return next;
    });

    // Sequential prefetch: await each one so they complete in order.
    // N+1 finishes before N+2 starts → correct priority even on slow connections.
    let cancelled = false;
    const runSequentialPrefetch = async () => {
      for (const name of toFetch) {
        if (cancelled) break;
        // Skip if already cached
        if (cache.current.has(`${name}_lo`)) continue;
        await prefetchImage(name);
      }
    };

    // Small delay so selected image renders before prefetch starts
    const timer = setTimeout(() => {
      runSequentialPrefetch();
    }, 200);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [selectedImage, isImageLoading, filteredImages, prefetchImage]);

  // ─────────────────────────────────────────────
  // Fetch image list
  // ─────────────────────────────────────────────
  const fetchImageList = async () => {
    try {
      setIsListLoading(true);
      const token = getToken();
      if (!token) { navigate("/login"); return; }

      const url =
        `${config.API_BASE_URL}/api/batch_viewer/list_images/` +
        `?batch_name=${encodeURIComponent(batchName)}` +
        `&rid_name=${encodeURIComponent(ridName)}`;

      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      });

      if (response.status === 401) { logout(); navigate("/login"); return; }
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const data = await response.json();
      setImageList(data.images || []);
      if (data.images?.length > 0) setSelectedImage(data.images[0].filename);
    } catch (err) {
      console.error("fetchImageList:", err);
      showNotification("Failed to load images", "error");
    } finally {
      setIsListLoading(false);
    }
  };

  // ─────────────────────────────────────────────
  // Multi-image search
  // ─────────────────────────────────────────────
  const parseMultiImageSearch = (text) => {
    if (!text?.trim()) return [];
    const sep = text.includes("\n") ? "\n" : text.includes(",") ? "," : " ";
    return text.split(sep).map((s) => s.trim()).filter(Boolean);
  };

  const handleMultiImageSearch = () => {
    const names = parseMultiImageSearch(searchTerm);
    if (!names.length) { showNotification("Enter at least one image name", "error"); return; }

    const matched = imageList
      .filter((img) => names.some((n) => img.filename.toLowerCase().includes(n.toLowerCase())))
      .sort((a, b) => a.filename.localeCompare(b.filename));

    if (!matched.length) { showNotification("No images found", "error"); return; }

    setFilteredImages(matched);
    setIsMultiSearchMode(true);
    setCurrentPage(1);
    setSelectedImage(matched[0].filename);
    showNotification(`Found ${matched.length} image(s)`, "success");
  };

  const clearMultiImageSearch = () => {
    setSearchTerm("");
    setIsMultiSearchMode(false);
    setCurrentPage(1);
  };

  // ─────────────────────────────────────────────
  // Navigation
  // ─────────────────────────────────────────────
  const handleImageSelect = (imageName) => setSelectedImage(imageName);

  const handlePreviousImage = () => {
    const idx = filteredImages.findIndex((img) => img.filename === selectedImage);
    if (idx > 0) {
      setSelectedImage(filteredImages[idx - 1].filename);
      const prevPage = Math.ceil(idx / itemsPerPage);
      if (prevPage !== currentPage) setCurrentPage(prevPage);
    }
  };

  const handleNextImage = () => {
    const idx = filteredImages.findIndex((img) => img.filename === selectedImage);
    if (idx < filteredImages.length - 1) {
      setSelectedImage(filteredImages[idx + 1].filename);
      const nextPage = Math.ceil((idx + 2) / itemsPerPage);
      if (nextPage !== currentPage) setCurrentPage(nextPage);
    }
  };

  const currentImageIndex = filteredImages.findIndex((img) => img.filename === selectedImage);

  return (
    <div className="flex h-screen bg-gray-100 relative">
      {notification.show && (
        <div className={`fixed top-4 right-4 p-4 rounded-lg shadow-lg z-50 transition-all duration-300 ${
            notification.type === "success" ? "bg-green-500" : "bg-red-500"
          } text-white`}
        >
          {notification.message}
        </div>
      )}

      <ImageList
        isSidebarCollapsed={isSidebarCollapsed}
        batchName={batchName}
        user={user}
        ridName={ridName}
        navigate={navigate}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        isListLoading={isListLoading}
        filteredImages={filteredImages}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        selectedImage={selectedImage}
        handleImageSelect={handleImageSelect}
        prefetchedImages={cachedSet}
        handlePageChange={setCurrentPage}
        isMultiSearchMode={isMultiSearchMode}
        onMultiImageSearch={handleMultiImageSearch}
        onClearMultiSearch={clearMultiImageSearch}
      />

      <button
        onClick={() => setIsSidebarCollapsed((v) => !v)}
        className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white border border-gray-300 rounded-r-lg p-2 hover:bg-gray-100 transition-all duration-300 shadow-md z-30"
        style={{ left: isSidebarCollapsed ? "0" : "calc(25% - 1px)", minWidth: "32px" }}
        title={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
      >
        {isSidebarCollapsed
          ? <ChevronRight className="w-5 h-5 text-gray-600" />
          : <ChevronLeft  className="w-5 h-5 text-gray-600" />}
      </button>

      <ImageDisplay
        isSidebarCollapsed={isSidebarCollapsed}
        selectedImage={selectedImage}
        imageUrl={imageUrl}
        setImageUrl={setImageUrl}
        isImageLoading={isImageLoading}
        isHighRes={isHighRes}
        setIsHighRes={setIsHighRes}
        filteredImages={filteredImages}
        currentImageIndex={currentImageIndex}
        loadImage={loadImage}
        showNotification={showNotification}
        isListLoading={isListLoading}
        onNavigatePrevious={handlePreviousImage}
        onNavigateNext={handleNextImage}
      />
    </div>
  );
};

export default BatchImageViewer;